[
	{
		"artsuch": "Flansch",
		"betaufnr": 125001,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125001",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.36,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.616714,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5529.0,
		"woF_15_25": 2680.0,
		"woF_25_50": 2852.0,
		"woF_50_100": 1382.0,
		"woF_100_150": 361.0,
		"woF_150_200": 122.0,
		"woF_200_400": 102.0,
		"woF_400_600": 9.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 483.0,
		"woF_300_400": 109.0,
		"woF_400_500": 4.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5529.0,
		"All_15_25": 2680.0,
		"All_25_50": 2852.0,
		"All_50_100": 1382.0,
		"All_100_150": 365.0,
		"All_150_200": 128.0,
		"All_200_400": 113.0,
		"All_400_600": 18.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 4.0,
		"All_200_300": 493.0,
		"All_300_400": 126.0,
		"All_400_500": 15.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 2.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 739.0,
		"Met_15_25": 815.0,
		"Met_25_50": 1496.0,
		"Met_50_100": 1083.0,
		"Met_100_150": 319.0,
		"Met_150_200": 119.0,
		"Met_200_400": 96.0,
		"Met_400_600": 8.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 438.0,
		"Met_300_400": 102.0,
		"Met_400_500": 4.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 1.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 473.0,
		"woFNM_1W": 171.0,
		"woFNM_2L": 311.0,
		"woFNM_2W": 94.0,
		"woFNM_3L": 310.0,
		"woFNM_3W": 84.0,
		"woFNM_4L": 296.0,
		"woFNM_4W": 78.0,
		"woFNM_5L": 260.0,
		"woFNM_5W": 105.0,
		"Met_1L": 1116.0,
		"Met_1W": 260.0,
		"Met_2L": 938.0,
		"Met_2W": 166.0,
		"Met_3L": 553.0,
		"Met_3W": 153.0,
		"Met_4L": 509.0,
		"Met_4W": 113.0,
		"Met_5L": 439.0,
		"Met_5W": 81.0,
		"Fib_Fmax1_Fmax": 2668.0,
		"Fib_Fmax1_Lstr": 2795.0,
		"Fib_Fmax2_Fmax": 2604.0,
		"Fib_Fmax2_Lstr": 4170.0,
		"Fib_Lstr1_Fmax": 2604.0,
		"Fib_Lstr1_Lstr": 4170.0,
		"Fib_Fmax_Sum_um": 19574.0,
		"Fib_Stretched_Sum_um": 23634.0,
		"woF_weighted_sum": 6676.0,
		"All_weighted_sum": 9418.0,
		"Met_weighted_sum": 6022.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125001,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1627.0,
		"nm_sum": 351.0,
		"sum_fibers": 38.0,
		"fibers_sum": 38.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125002,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125002",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.34,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.277881,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 3469.0,
		"woF_15_25": 1777.0,
		"woF_25_50": 1784.0,
		"woF_50_100": 783.0,
		"woF_100_150": 131.0,
		"woF_150_200": 32.0,
		"woF_200_400": 20.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 163.0,
		"woF_300_400": 22.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 3469.0,
		"All_15_25": 1777.0,
		"All_25_50": 1784.0,
		"All_50_100": 783.0,
		"All_100_150": 134.0,
		"All_150_200": 35.0,
		"All_200_400": 26.0,
		"All_400_600": 3.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 169.0,
		"All_300_400": 29.0,
		"All_400_500": 5.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 453.0,
		"Met_15_25": 508.0,
		"Met_25_50": 977.0,
		"Met_50_100": 602.0,
		"Met_100_150": 117.0,
		"Met_150_200": 31.0,
		"Met_200_400": 18.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 148.0,
		"Met_300_400": 20.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 274.0,
		"woFNM_1W": 49.0,
		"woFNM_2L": 228.0,
		"woFNM_2W": 72.0,
		"woFNM_3L": 159.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 146.0,
		"woFNM_4W": 36.0,
		"woFNM_5L": 128.0,
		"woFNM_5W": 59.0,
		"Met_1L": 431.0,
		"Met_1W": 94.0,
		"Met_2L": 415.0,
		"Met_2W": 77.0,
		"Met_3L": 398.0,
		"Met_3W": 108.0,
		"Met_4L": 312.0,
		"Met_4W": 113.0,
		"Met_5L": 277.0,
		"Met_5W": 38.0,
		"Fib_Fmax1_Fmax": 1755.0,
		"Fib_Fmax1_Lstr": 6776.0,
		"Fib_Fmax2_Fmax": 1690.0,
		"Fib_Fmax2_Lstr": 2102.0,
		"Fib_Lstr1_Fmax": 1755.0,
		"Fib_Lstr1_Lstr": 6776.0,
		"Fib_Fmax_Sum_um": 8575.0,
		"Fib_Stretched_Sum_um": 14717.0,
		"woF_weighted_sum": 2043.0,
		"All_weighted_sum": 3474.0,
		"Met_weighted_sum": 1765.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125002,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 770.0,
		"nm_sum": 198.0,
		"sum_fibers": 18.0,
		"fibers_sum": 18.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125003,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125003",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.32,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.233865,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 2464.0,
		"woF_15_25": 1262.0,
		"woF_25_50": 1198.0,
		"woF_50_100": 591.0,
		"woF_100_150": 125.0,
		"woF_150_200": 41.0,
		"woF_200_400": 23.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 166.0,
		"woF_300_400": 23.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2464.0,
		"All_15_25": 1262.0,
		"All_25_50": 1198.0,
		"All_50_100": 591.0,
		"All_100_150": 130.0,
		"All_150_200": 46.0,
		"All_200_400": 34.0,
		"All_400_600": 7.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 3.0,
		"All_200_300": 176.0,
		"All_300_400": 39.0,
		"All_400_500": 7.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 336.0,
		"Met_15_25": 354.0,
		"Met_25_50": 584.0,
		"Met_50_100": 458.0,
		"Met_100_150": 114.0,
		"Met_150_200": 38.0,
		"Met_200_400": 22.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 152.0,
		"Met_300_400": 22.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 264.0,
		"woFNM_1W": 157.0,
		"woFNM_2L": 178.0,
		"woFNM_2W": 89.0,
		"woFNM_3L": 169.0,
		"woFNM_3W": 71.0,
		"woFNM_4L": 152.0,
		"woFNM_4W": 100.0,
		"woFNM_5L": 143.0,
		"woFNM_5W": 56.0,
		"Met_1L": 312.0,
		"Met_1W": 63.0,
		"Met_2L": 307.0,
		"Met_2W": 45.0,
		"Met_3L": 271.0,
		"Met_3W": 45.0,
		"Met_4L": 249.0,
		"Met_4W": 49.0,
		"Met_5L": 247.0,
		"Met_5W": 40.0,
		"Fib_Fmax1_Fmax": 2048.0,
		"Fib_Fmax1_Lstr": 2723.0,
		"Fib_Fmax2_Fmax": 1137.0,
		"Fib_Fmax2_Lstr": 1198.0,
		"Fib_Lstr1_Fmax": 2048.0,
		"Fib_Lstr1_Lstr": 2723.0,
		"Fib_Fmax_Sum_um": 13486.0,
		"Fib_Stretched_Sum_um": 17833.0,
		"woF_weighted_sum": 1828.0,
		"All_weighted_sum": 4005.0,
		"Met_weighted_sum": 1608.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125003,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 632.0,
		"nm_sum": 148.0,
		"sum_fibers": 32.0,
		"fibers_sum": 32.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125004,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125004",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.18,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.414511,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 7710.0,
		"woF_15_25": 4414.0,
		"woF_25_50": 2228.0,
		"woF_50_100": 747.0,
		"woF_100_150": 127.0,
		"woF_150_200": 41.0,
		"woF_200_400": 26.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 168.0,
		"woF_300_400": 26.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 7710.0,
		"All_15_25": 4414.0,
		"All_25_50": 2228.0,
		"All_50_100": 747.0,
		"All_100_150": 137.0,
		"All_150_200": 46.0,
		"All_200_400": 37.0,
		"All_400_600": 2.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 183.0,
		"All_300_400": 39.0,
		"All_400_500": 5.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 385.0,
		"Met_15_25": 689.0,
		"Met_25_50": 902.0,
		"Met_50_100": 537.0,
		"Met_100_150": 113.0,
		"Met_150_200": 40.0,
		"Met_200_400": 23.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 153.0,
		"Met_300_400": 23.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 260.0,
		"woFNM_1W": 75.0,
		"woFNM_2L": 228.0,
		"woFNM_2W": 107.0,
		"woFNM_3L": 210.0,
		"woFNM_3W": 156.0,
		"woFNM_4L": 155.0,
		"woFNM_4W": 102.0,
		"woFNM_5L": 149.0,
		"woFNM_5W": 97.0,
		"Met_1L": 395.0,
		"Met_1W": 39.0,
		"Met_2L": 294.0,
		"Met_2W": 43.0,
		"Met_3L": 275.0,
		"Met_3W": 48.0,
		"Met_4L": 274.0,
		"Met_4W": 51.0,
		"Met_5L": 264.0,
		"Met_5W": 91.0,
		"Fib_Fmax1_Fmax": 1784.0,
		"Fib_Fmax1_Lstr": 2014.0,
		"Fib_Fmax2_Fmax": 1017.0,
		"Fib_Fmax2_Lstr": 1197.0,
		"Fib_Lstr1_Fmax": 1784.0,
		"Fib_Lstr1_Lstr": 2014.0,
		"Fib_Fmax_Sum_um": 11291.0,
		"Fib_Stretched_Sum_um": 12584.0,
		"woF_weighted_sum": 2040.0,
		"All_weighted_sum": 3661.0,
		"Met_weighted_sum": 1717.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125004,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 713.0,
		"nm_sum": 228.0,
		"sum_fibers": 33.0,
		"fibers_sum": 33.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125005,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125005",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.16,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.282299,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5310.0,
		"woF_15_25": 2799.0,
		"woF_25_50": 1526.0,
		"woF_50_100": 539.0,
		"woF_100_150": 97.0,
		"woF_150_200": 34.0,
		"woF_200_400": 13.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 131.0,
		"woF_300_400": 13.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5310.0,
		"All_15_25": 2799.0,
		"All_25_50": 1526.0,
		"All_50_100": 539.0,
		"All_100_150": 98.0,
		"All_150_200": 41.0,
		"All_200_400": 21.0,
		"All_400_600": 7.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 139.0,
		"All_300_400": 26.0,
		"All_400_500": 5.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 260.0,
		"Met_15_25": 421.0,
		"Met_25_50": 634.0,
		"Met_50_100": 371.0,
		"Met_100_150": 72.0,
		"Met_150_200": 26.0,
		"Met_200_400": 10.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 98.0,
		"Met_300_400": 10.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 282.0,
		"woFNM_1W": 220.0,
		"woFNM_2L": 252.0,
		"woFNM_2W": 113.0,
		"woFNM_3L": 225.0,
		"woFNM_3W": 59.0,
		"woFNM_4L": 167.0,
		"woFNM_4W": 59.0,
		"woFNM_5L": 167.0,
		"woFNM_5W": 16.0,
		"Met_1L": 571.0,
		"Met_1W": 64.0,
		"Met_2L": 312.0,
		"Met_2W": 125.0,
		"Met_3L": 265.0,
		"Met_3W": 75.0,
		"Met_4L": 251.0,
		"Met_4W": 38.0,
		"Met_5L": 251.0,
		"Met_5W": 15.0,
		"Fib_Fmax1_Fmax": 1466.0,
		"Fib_Fmax1_Lstr": 4074.0,
		"Fib_Fmax2_Fmax": 946.0,
		"Fib_Fmax2_Lstr": 2060.0,
		"Fib_Lstr1_Fmax": 1466.0,
		"Fib_Lstr1_Lstr": 4074.0,
		"Fib_Fmax_Sum_um": 9531.0,
		"Fib_Stretched_Sum_um": 14095.0,
		"woF_weighted_sum": 1505.0,
		"All_weighted_sum": 2772.0,
		"Met_weighted_sum": 1117.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125005,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 480.0,
		"nm_sum": 204.0,
		"sum_fibers": 25.0,
		"fibers_sum": 25.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125006,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125006",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.17,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.239836,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4259.0,
		"woF_15_25": 2050.0,
		"woF_25_50": 1172.0,
		"woF_50_100": 443.0,
		"woF_100_150": 77.0,
		"woF_150_200": 35.0,
		"woF_200_400": 19.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 112.0,
		"woF_300_400": 20.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4259.0,
		"All_15_25": 2050.0,
		"All_25_50": 1172.0,
		"All_50_100": 443.0,
		"All_100_150": 78.0,
		"All_150_200": 36.0,
		"All_200_400": 28.0,
		"All_400_600": 5.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 1.0,
		"All_200_300": 114.0,
		"All_300_400": 31.0,
		"All_400_500": 4.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 287.0,
		"Met_15_25": 379.0,
		"Met_25_50": 468.0,
		"Met_50_100": 310.0,
		"Met_100_150": 54.0,
		"Met_150_200": 29.0,
		"Met_200_400": 16.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 83.0,
		"Met_300_400": 16.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 407.0,
		"woFNM_1W": 70.0,
		"woFNM_2L": 278.0,
		"woFNM_2W": 22.0,
		"woFNM_3L": 216.0,
		"woFNM_3W": 140.0,
		"woFNM_4L": 204.0,
		"woFNM_4W": 81.0,
		"woFNM_5L": 172.0,
		"woFNM_5W": 90.0,
		"Met_1L": 274.0,
		"Met_1W": 106.0,
		"Met_2L": 271.0,
		"Met_2W": 43.0,
		"Met_3L": 269.0,
		"Met_3W": 66.0,
		"Met_4L": 261.0,
		"Met_4W": 31.0,
		"Met_5L": 259.0,
		"Met_5W": 38.0,
		"Fib_Fmax1_Fmax": 2286.0,
		"Fib_Fmax1_Lstr": 2510.0,
		"Fib_Fmax2_Fmax": 894.0,
		"Fib_Fmax2_Lstr": 1168.0,
		"Fib_Lstr1_Fmax": 2286.0,
		"Fib_Lstr1_Lstr": 2510.0,
		"Fib_Fmax_Sum_um": 8067.0,
		"Fib_Stretched_Sum_um": 9720.0,
		"woF_weighted_sum": 1434.0,
		"All_weighted_sum": 2391.0,
		"Met_weighted_sum": 1043.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125006,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 409.0,
		"nm_sum": 166.0,
		"sum_fibers": 16.0,
		"fibers_sum": 16.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125007,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125007",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.07,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.286424,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 6017.0,
		"woF_15_25": 3034.0,
		"woF_25_50": 1501.0,
		"woF_50_100": 503.0,
		"woF_100_150": 98.0,
		"woF_150_200": 32.0,
		"woF_200_400": 27.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1023.0,
		"woF_300_400": 503.0,
		"woF_400_500": 161.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 6017.0,
		"All_15_25": 3034.0,
		"All_25_50": 1501.0,
		"All_50_100": 503.0,
		"All_100_150": 98.0,
		"All_150_200": 35.0,
		"All_200_400": 36.0,
		"All_400_600": 4.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 1023.0,
		"All_300_400": 503.0,
		"All_400_500": 175.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 273.0,
		"Met_15_25": 587.0,
		"Met_25_50": 716.0,
		"Met_50_100": 403.0,
		"Met_100_150": 81.0,
		"Met_150_200": 30.0,
		"Met_200_400": 26.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 540.0,
		"Met_300_400": 403.0,
		"Met_400_500": 141.0,
		"Met_500_600": null,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 214.0,
		"woFNM_1W": 123.0,
		"woFNM_2L": 155.0,
		"woFNM_2W": 59.0,
		"woFNM_3L": 151.0,
		"woFNM_3W": 27.0,
		"woFNM_4L": 135.0,
		"woFNM_4W": 11.0,
		"woFNM_5L": 133.0,
		"woFNM_5W": 16.0,
		"Met_1L": 611.0,
		"Met_1W": 92.0,
		"Met_2L": 512.0,
		"Met_2W": 65.0,
		"Met_3L": 494.0,
		"Met_3W": 85.0,
		"Met_4L": 485.0,
		"Met_4W": 135.0,
		"Met_5L": 340.0,
		"Met_5W": 49.0,
		"Fib_Fmax1_Fmax": 1745.0,
		"Fib_Fmax1_Lstr": 2199.0,
		"Fib_Fmax2_Fmax": 940.0,
		"Fib_Fmax2_Lstr": 976.0,
		"Fib_Lstr1_Fmax": 1745.0,
		"Fib_Lstr1_Lstr": 2199.0,
		"Fib_Fmax_Sum_um": 5913.0,
		"Fib_Stretched_Sum_um": 6789.0,
		"woF_weighted_sum": 1951.0,
		"All_weighted_sum": 2730.0,
		"Met_weighted_sum": 1749.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125007,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 544.0,
		"nm_sum": 120.0,
		"sum_fibers": 15.0,
		"fibers_sum": 15.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125008,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125008",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.29,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.426462,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 7104.0,
		"woF_15_25": 3774.0,
		"woF_25_50": 2350.0,
		"woF_50_100": 877.0,
		"woF_100_150": 153.0,
		"woF_150_200": 33.0,
		"woF_200_400": 32.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1577.0,
		"woF_300_400": 877.0,
		"woF_400_500": 219.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 7104.0,
		"All_15_25": 3774.0,
		"All_25_50": 2350.0,
		"All_50_100": 877.0,
		"All_100_150": 153.0,
		"All_150_200": 33.0,
		"All_200_400": 39.0,
		"All_400_600": 2.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1577.0,
		"All_300_400": 877.0,
		"All_400_500": 229.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 410.0,
		"Met_15_25": 779.0,
		"Met_25_50": 1054.0,
		"Met_50_100": 596.0,
		"Met_100_150": 115.0,
		"Met_150_200": 32.0,
		"Met_200_400": 23.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 753.0,
		"Met_300_400": 596.0,
		"Met_400_500": 171.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 376.0,
		"woFNM_1W": 238.0,
		"woFNM_2L": 313.0,
		"woFNM_2W": 221.0,
		"woFNM_3L": 282.0,
		"woFNM_3W": 199.0,
		"woFNM_4L": 246.0,
		"woFNM_4W": 181.0,
		"woFNM_5L": 228.0,
		"woFNM_5W": 124.0,
		"Met_1L": 724.0,
		"Met_1W": 76.0,
		"Met_2L": 395.0,
		"Met_2W": 43.0,
		"Met_3L": 391.0,
		"Met_3W": 73.0,
		"Met_4L": 347.0,
		"Met_4W": 68.0,
		"Met_5L": 324.0,
		"Met_5W": 81.0,
		"Fib_Fmax1_Fmax": 737.0,
		"Fib_Fmax1_Lstr": 836.0,
		"Fib_Fmax2_Fmax": 564.0,
		"Fib_Fmax2_Lstr": 586.0,
		"Fib_Lstr1_Fmax": 415.0,
		"Fib_Lstr1_Lstr": 905.0,
		"Fib_Fmax_Sum_um": 3451.0,
		"Fib_Stretched_Sum_um": 4690.0,
		"woF_weighted_sum": 2442.0,
		"All_weighted_sum": 2826.0,
		"Met_weighted_sum": 1856.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125008,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 767.0,
		"nm_sum": 329.0,
		"sum_fibers": 10.0,
		"fibers_sum": 10.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125009,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125009",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.17,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.357735,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 6780.0,
		"woF_15_25": 3561.0,
		"woF_25_50": 1910.0,
		"woF_50_100": 655.0,
		"woF_100_150": 140.0,
		"woF_150_200": 40.0,
		"woF_200_400": 26.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1295.0,
		"woF_300_400": 655.0,
		"woF_400_500": 208.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 6780.0,
		"All_15_25": 3561.0,
		"All_25_50": 1910.0,
		"All_50_100": 655.0,
		"All_100_150": 140.0,
		"All_150_200": 41.0,
		"All_200_400": 28.0,
		"All_400_600": 5.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 1295.0,
		"All_300_400": 655.0,
		"All_400_500": 217.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 452.0,
		"Met_15_25": 727.0,
		"Met_25_50": 995.0,
		"Met_50_100": 504.0,
		"Met_100_150": 116.0,
		"Met_150_200": 38.0,
		"Met_200_400": 24.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 752.0,
		"Met_300_400": 504.0,
		"Met_400_500": 180.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 255.0,
		"woFNM_1W": 137.0,
		"woFNM_2L": 246.0,
		"woFNM_2W": 65.0,
		"woFNM_3L": 178.0,
		"woFNM_3W": 138.0,
		"woFNM_4L": 172.0,
		"woFNM_4W": 32.0,
		"woFNM_5L": 148.0,
		"woFNM_5W": 16.0,
		"Met_1L": 475.0,
		"Met_1W": 49.0,
		"Met_2L": 464.0,
		"Met_2W": 59.0,
		"Met_3L": 369.0,
		"Met_3W": 49.0,
		"Met_4L": 342.0,
		"Met_4W": 81.0,
		"Met_5L": 326.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 1468.0,
		"Fib_Fmax1_Lstr": 1517.0,
		"Fib_Fmax2_Fmax": 1399.0,
		"Fib_Fmax2_Lstr": 1456.0,
		"Fib_Lstr1_Fmax": 1468.0,
		"Fib_Lstr1_Lstr": 1517.0,
		"Fib_Fmax_Sum_um": 7543.0,
		"Fib_Stretched_Sum_um": 8458.0,
		"woF_weighted_sum": 2119.0,
		"All_weighted_sum": 3584.0,
		"Met_weighted_sum": 1822.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125009,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 684.0,
		"nm_sum": 179.0,
		"sum_fibers": 11.0,
		"fibers_sum": 11.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125010,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125010",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.431389,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 9981.0,
		"woF_15_25": 3950.0,
		"woF_25_50": 2092.0,
		"woF_50_100": 840.0,
		"woF_100_150": 214.0,
		"woF_150_200": 59.0,
		"woF_200_400": 48.0,
		"woF_400_600": 7.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 273.0,
		"woF_300_400": 54.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 9981.0,
		"All_15_25": 3950.0,
		"All_25_50": 2092.0,
		"All_50_100": 840.0,
		"All_100_150": 214.0,
		"All_150_200": 60.0,
		"All_200_400": 57.0,
		"All_400_600": 9.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 3.0,
		"All_200_300": 274.0,
		"All_300_400": 64.0,
		"All_400_500": 6.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 695.0,
		"Met_15_25": 854.0,
		"Met_25_50": 968.0,
		"Met_50_100": 619.0,
		"Met_100_150": 190.0,
		"Met_150_200": 54.0,
		"Met_200_400": 45.0,
		"Met_400_600": 7.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 244.0,
		"Met_300_400": 51.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 269.0,
		"woFNM_1W": 151.0,
		"woFNM_2L": 228.0,
		"woFNM_2W": 70.0,
		"woFNM_3L": 211.0,
		"woFNM_3W": 97.0,
		"woFNM_4L": 178.0,
		"woFNM_4W": 27.0,
		"woFNM_5L": 164.0,
		"woFNM_5W": 38.0,
		"Met_1L": 566.0,
		"Met_1W": 54.0,
		"Met_2L": 490.0,
		"Met_2W": 42.0,
		"Met_3L": 460.0,
		"Met_3W": 38.0,
		"Met_4L": 434.0,
		"Met_4W": 123.0,
		"Met_5L": 409.0,
		"Met_5W": 94.0,
		"Fib_Fmax1_Fmax": 1939.0,
		"Fib_Fmax1_Lstr": 2116.0,
		"Fib_Fmax2_Fmax": 1309.0,
		"Fib_Fmax2_Lstr": 1439.0,
		"Fib_Lstr1_Fmax": 1939.0,
		"Fib_Lstr1_Lstr": 2116.0,
		"Fib_Fmax_Sum_um": 8901.0,
		"Fib_Stretched_Sum_um": 10395.0,
		"woF_weighted_sum": 3443.0,
		"All_weighted_sum": 5068.0,
		"Met_weighted_sum": 3033.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125010,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 915.0,
		"nm_sum": 253.0,
		"sum_fibers": 16.0,
		"fibers_sum": 16.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125011,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125011",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.4,
		"Date_of_arrival": "2021-08-11T15:00:00",
		"Date_of_Extraction": "2021-08-11T15:00:00",
		"Date_of_Analysis": "2021-08-11T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.59109,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 10984.0,
		"woF_15_25": 4900.0,
		"woF_25_50": 2776.0,
		"woF_50_100": 1201.0,
		"woF_100_150": 256.0,
		"woF_150_200": 99.0,
		"woF_200_400": 81.0,
		"woF_400_600": 13.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 355.0,
		"woF_300_400": 88.0,
		"woF_400_500": 9.0,
		"woF_500_600": null,
		"woF_600_700": 2.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 10984.0,
		"All_15_25": 4900.0,
		"All_25_50": 2776.0,
		"All_50_100": 1201.0,
		"All_100_150": 257.0,
		"All_150_200": 99.0,
		"All_200_400": 87.0,
		"All_400_600": 16.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 356.0,
		"All_300_400": 97.0,
		"All_400_500": 11.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 653.0,
		"Met_15_25": 934.0,
		"Met_25_50": 1226.0,
		"Met_50_100": 847.0,
		"Met_100_150": 198.0,
		"Met_150_200": 87.0,
		"Met_200_400": 71.0,
		"Met_400_600": 12.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 285.0,
		"Met_300_400": 78.0,
		"Met_400_500": 8.0,
		"Met_500_600": null,
		"Met_600_700": 2.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 1.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 581.0,
		"woFNM_1W": 270.0,
		"woFNM_2L": 326.0,
		"woFNM_2W": 46.0,
		"woFNM_3L": 303.0,
		"woFNM_3W": 41.0,
		"woFNM_4L": 255.0,
		"woFNM_4W": 92.0,
		"woFNM_5L": 237.0,
		"woFNM_5W": 49.0,
		"Met_1L": 1693.0,
		"Met_1W": 355.0,
		"Met_2L": 694.0,
		"Met_2W": 92.0,
		"Met_3L": 625.0,
		"Met_3W": 92.0,
		"Met_4L": 531.0,
		"Met_4W": 109.0,
		"Met_5L": 526.0,
		"Met_5W": 157.0,
		"Fib_Fmax1_Fmax": 1134.0,
		"Fib_Fmax1_Lstr": 1907.0,
		"Fib_Fmax2_Fmax": 972.0,
		"Fib_Fmax2_Lstr": 1775.0,
		"Fib_Lstr1_Fmax": 1134.0,
		"Fib_Lstr1_Lstr": 1907.0,
		"Fib_Fmax_Sum_um": 5090.0,
		"Fib_Stretched_Sum_um": 7539.0,
		"woF_weighted_sum": 5932.0,
		"All_weighted_sum": 6768.0,
		"Met_weighted_sum": 5014.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125011,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1218.0,
		"nm_sum": 435.0,
		"sum_fibers": 12.0,
		"fibers_sum": 12.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125012,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125012",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.33,
		"Date_of_arrival": "2021-08-12T15:00:00",
		"Date_of_Extraction": "2021-08-12T15:00:00",
		"Date_of_Analysis": "2021-08-12T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.445233,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8598.0,
		"woF_15_25": 3805.0,
		"woF_25_50": 2066.0,
		"woF_50_100": 848.0,
		"woF_100_150": 198.0,
		"woF_150_200": 75.0,
		"woF_200_400": 72.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 3.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 273.0,
		"woF_300_400": 75.0,
		"woF_400_500": 5.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8598.0,
		"All_15_25": 3805.0,
		"All_25_50": 2066.0,
		"All_50_100": 848.0,
		"All_100_150": 199.0,
		"All_150_200": 75.0,
		"All_200_400": 82.0,
		"All_400_600": 6.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 274.0,
		"All_300_400": 86.0,
		"All_400_500": 7.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 634.0,
		"Met_15_25": 795.0,
		"Met_25_50": 996.0,
		"Met_50_100": 612.0,
		"Met_100_150": 152.0,
		"Met_150_200": 57.0,
		"Met_200_400": 57.0,
		"Met_400_600": 4.0,
		"Met_600_1000": 3.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 209.0,
		"Met_300_400": 60.0,
		"Met_400_500": 5.0,
		"Met_500_600": null,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 1.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 321.0,
		"woFNM_1W": 38.0,
		"woFNM_2L": 282.0,
		"woFNM_2W": 38.0,
		"woFNM_3L": 277.0,
		"woFNM_3W": 79.0,
		"woFNM_4L": 277.0,
		"woFNM_4W": 221.0,
		"woFNM_5L": 273.0,
		"woFNM_5W": 49.0,
		"Met_1L": 1157.0,
		"Met_1W": 59.0,
		"Met_2L": 937.0,
		"Met_2W": 54.0,
		"Met_3L": 863.0,
		"Met_3W": 127.0,
		"Met_4L": 647.0,
		"Met_4W": 84.0,
		"Met_5L": 594.0,
		"Met_5W": 35.0,
		"Fib_Fmax1_Fmax": 1600.0,
		"Fib_Fmax1_Lstr": 1629.0,
		"Fib_Fmax2_Fmax": 570.0,
		"Fib_Fmax2_Lstr": 656.0,
		"Fib_Lstr1_Fmax": 1600.0,
		"Fib_Lstr1_Lstr": 1629.0,
		"Fib_Fmax_Sum_um": 5382.0,
		"Fib_Stretched_Sum_um": 5651.0,
		"woF_weighted_sum": 4555.0,
		"All_weighted_sum": 5247.0,
		"Met_weighted_sum": 3733.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125012,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 886.0,
		"nm_sum": 315.0,
		"sum_fibers": 14.0,
		"fibers_sum": 14.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125013,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125013",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.5,
		"Date_of_arrival": "2021-08-13T15:00:00",
		"Date_of_Extraction": "2021-08-13T15:00:00",
		"Date_of_Analysis": "2021-08-13T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.494334,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 9620.0,
		"woF_15_25": 3857.0,
		"woF_25_50": 2145.0,
		"woF_50_100": 908.0,
		"woF_100_150": 203.0,
		"woF_150_200": 77.0,
		"woF_200_400": 56.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 280.0,
		"woF_300_400": 56.0,
		"woF_400_500": 3.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 9620.0,
		"All_15_25": 3857.0,
		"All_25_50": 2145.0,
		"All_50_100": 908.0,
		"All_100_150": 206.0,
		"All_150_200": 80.0,
		"All_200_400": 72.0,
		"All_400_600": 4.0,
		"All_600_1000": 9.0,
		"All_gt_1000": 6.0,
		"All_200_300": 286.0,
		"All_300_400": 72.0,
		"All_400_500": 19.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 3.0,
		"All_800_900": 3.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 3.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 436.0,
		"Met_15_25": 661.0,
		"Met_25_50": 802.0,
		"Met_50_100": 553.0,
		"Met_100_150": 130.0,
		"Met_150_200": 47.0,
		"Met_200_400": 47.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 177.0,
		"Met_300_400": 47.0,
		"Met_400_500": 2.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 717.0,
		"woFNM_1W": 108.0,
		"woFNM_2L": 355.0,
		"woFNM_2W": 71.0,
		"woFNM_3L": 339.0,
		"woFNM_3W": 135.0,
		"woFNM_4L": 285.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 280.0,
		"woFNM_5W": 103.0,
		"Met_1L": 1221.0,
		"Met_1W": 205.0,
		"Met_2L": 872.0,
		"Met_2W": 250.0,
		"Met_3L": 388.0,
		"Met_3W": 86.0,
		"Met_4L": 378.0,
		"Met_4W": 32.0,
		"Met_5L": 352.0,
		"Met_5W": 41.0,
		"Fib_Fmax1_Fmax": 2103.0,
		"Fib_Fmax1_Lstr": 2200.0,
		"Fib_Fmax2_Fmax": 1978.0,
		"Fib_Fmax2_Lstr": 2004.0,
		"Fib_Lstr1_Fmax": 1566.0,
		"Fib_Lstr1_Lstr": 3377.0,
		"Fib_Fmax_Sum_um": 22690.0,
		"Fib_Stretched_Sum_um": 26971.0,
		"woF_weighted_sum": 3997.0,
		"All_weighted_sum": 7556.0,
		"Met_weighted_sum": 2792.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125013,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 779.0,
		"nm_sum": 468.0,
		"sum_fibers": 37.0,
		"fibers_sum": 37.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125014,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125014",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.7,
		"Date_of_arrival": "2021-08-14T15:00:00",
		"Date_of_Extraction": "2021-08-14T15:00:00",
		"Date_of_Analysis": "2021-08-14T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.526967,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8723.0,
		"woF_15_25": 3698.0,
		"woF_25_50": 2219.0,
		"woF_50_100": 980.0,
		"woF_100_150": 245.0,
		"woF_150_200": 108.0,
		"woF_200_400": 73.0,
		"woF_400_600": 12.0,
		"woF_600_1000": 3.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 353.0,
		"woF_300_400": 84.0,
		"woF_400_500": 4.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 1.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8723.0,
		"All_15_25": 3698.0,
		"All_25_50": 2219.0,
		"All_50_100": 980.0,
		"All_100_150": 245.0,
		"All_150_200": 108.0,
		"All_200_400": 86.0,
		"All_400_600": 22.0,
		"All_600_1000": 10.0,
		"All_gt_1000": 2.0,
		"All_200_300": 353.0,
		"All_300_400": 105.0,
		"All_400_500": 15.0,
		"All_500_600": null,
		"All_600_700": 5.0,
		"All_700_800": 2.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 582.0,
		"Met_15_25": 847.0,
		"Met_25_50": 986.0,
		"Met_50_100": 648.0,
		"Met_100_150": 164.0,
		"Met_150_200": 70.0,
		"Met_200_400": 56.0,
		"Met_400_600": 11.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 234.0,
		"Met_300_400": 67.0,
		"Met_400_500": 2.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 663.0,
		"woFNM_1W": 65.0,
		"woFNM_2L": 593.0,
		"woFNM_2W": 84.0,
		"woFNM_3L": 344.0,
		"woFNM_3W": 162.0,
		"woFNM_4L": 282.0,
		"woFNM_4W": 69.0,
		"woFNM_5L": 276.0,
		"woFNM_5W": 22.0,
		"Met_1L": 899.0,
		"Met_1W": 117.0,
		"Met_2L": 737.0,
		"Met_2W": 36.0,
		"Met_3L": 473.0,
		"Met_3W": 289.0,
		"Met_4L": 469.0,
		"Met_4W": 46.0,
		"Met_5L": 445.0,
		"Met_5W": 97.0,
		"Fib_Fmax1_Fmax": 2352.0,
		"Fib_Fmax1_Lstr": 2680.0,
		"Fib_Fmax2_Fmax": 1288.0,
		"Fib_Fmax2_Lstr": 1326.0,
		"Fib_Lstr1_Fmax": 2352.0,
		"Fib_Lstr1_Lstr": 2680.0,
		"Fib_Fmax_Sum_um": 17193.0,
		"Fib_Stretched_Sum_um": 18673.0,
		"woF_weighted_sum": 5300.0,
		"All_weighted_sum": 7956.0,
		"Met_weighted_sum": 3822.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125014,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 951.0,
		"nm_sum": 470.0,
		"sum_fibers": 31.0,
		"fibers_sum": 31.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125015,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125015",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.44,
		"Date_of_arrival": "2021-08-15T15:00:00",
		"Date_of_Extraction": "2021-08-15T15:00:00",
		"Date_of_Analysis": "2021-08-15T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.363754,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5940.0,
		"woF_15_25": 2538.0,
		"woF_25_50": 1474.0,
		"woF_50_100": 714.0,
		"woF_100_150": 179.0,
		"woF_150_200": 66.0,
		"woF_200_400": 52.0,
		"woF_400_600": 7.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 245.0,
		"woF_300_400": 59.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5940.0,
		"All_15_25": 2538.0,
		"All_25_50": 1474.0,
		"All_50_100": 714.0,
		"All_100_150": 181.0,
		"All_150_200": 68.0,
		"All_200_400": 62.0,
		"All_400_600": 10.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 249.0,
		"All_300_400": 70.0,
		"All_400_500": 7.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 371.0,
		"Met_15_25": 568.0,
		"Met_25_50": 704.0,
		"Met_50_100": 554.0,
		"Met_100_150": 156.0,
		"Met_150_200": 63.0,
		"Met_200_400": 51.0,
		"Met_400_600": 7.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 219.0,
		"Met_300_400": 58.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 213.0,
		"woFNM_1W": 22.0,
		"woFNM_2L": 199.0,
		"woFNM_2W": 126.0,
		"woFNM_3L": 164.0,
		"woFNM_3W": 22.0,
		"woFNM_4L": 163.0,
		"woFNM_4W": 49.0,
		"woFNM_5L": 135.0,
		"woFNM_5W": 54.0,
		"Met_1L": 778.0,
		"Met_1W": 102.0,
		"Met_2L": 498.0,
		"Met_2W": 145.0,
		"Met_3L": 467.0,
		"Met_3W": 76.0,
		"Met_4L": 464.0,
		"Met_4W": 43.0,
		"Met_5L": 452.0,
		"Met_5W": 108.0,
		"Fib_Fmax1_Fmax": 1344.0,
		"Fib_Fmax1_Lstr": 2026.0,
		"Fib_Fmax2_Fmax": 1042.0,
		"Fib_Fmax2_Lstr": 1144.0,
		"Fib_Lstr1_Fmax": 1344.0,
		"Fib_Lstr1_Lstr": 2026.0,
		"Fib_Fmax_Sum_um": 8971.0,
		"Fib_Stretched_Sum_um": 10629.0,
		"woF_weighted_sum": 3448.0,
		"All_weighted_sum": 4914.0,
		"Met_weighted_sum": 3153.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125015,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 832.0,
		"nm_sum": 187.0,
		"sum_fibers": 21.0,
		"fibers_sum": 21.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125016,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125016",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.16,
		"Date_of_arrival": "2021-08-16T15:00:00",
		"Date_of_Extraction": "2021-08-16T15:00:00",
		"Date_of_Analysis": "2021-08-16T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.199351,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4751.0,
		"woF_15_25": 1728.0,
		"woF_25_50": 1192.0,
		"woF_50_100": 379.0,
		"woF_100_150": 91.0,
		"woF_150_200": 20.0,
		"woF_200_400": 14.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 111.0,
		"woF_300_400": 17.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4751.0,
		"All_15_25": 1728.0,
		"All_25_50": 1192.0,
		"All_50_100": 379.0,
		"All_100_150": 92.0,
		"All_150_200": 20.0,
		"All_200_400": 19.0,
		"All_400_600": 6.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 1.0,
		"All_200_300": 112.0,
		"All_300_400": 24.0,
		"All_400_500": 5.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 426.0,
		"Met_15_25": 363.0,
		"Met_25_50": 421.0,
		"Met_50_100": 227.0,
		"Met_100_150": 61.0,
		"Met_150_200": 15.0,
		"Met_200_400": 11.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 76.0,
		"Met_300_400": 12.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 672.0,
		"woFNM_1W": 463.0,
		"woFNM_2L": 477.0,
		"woFNM_2W": 162.0,
		"woFNM_3L": 411.0,
		"woFNM_3W": 171.0,
		"woFNM_4L": 226.0,
		"woFNM_4W": 198.0,
		"woFNM_5L": 224.0,
		"woFNM_5W": 81.0,
		"Met_1L": 424.0,
		"Met_1W": 36.0,
		"Met_2L": 397.0,
		"Met_2W": 38.0,
		"Met_3L": 325.0,
		"Met_3W": 121.0,
		"Met_4L": 283.0,
		"Met_4W": 110.0,
		"Met_5L": 239.0,
		"Met_5W": 58.0,
		"Fib_Fmax1_Fmax": 1475.0,
		"Fib_Fmax1_Lstr": 1552.0,
		"Fib_Fmax2_Fmax": 880.0,
		"Fib_Fmax2_Lstr": 945.0,
		"Fib_Lstr1_Fmax": 1475.0,
		"Fib_Lstr1_Lstr": 1552.0,
		"Fib_Fmax_Sum_um": 5824.0,
		"Fib_Stretched_Sum_um": 6133.0,
		"woF_weighted_sum": 1483.0,
		"All_weighted_sum": 2447.0,
		"Met_weighted_sum": 846.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125016,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 315.0,
		"nm_sum": 193.0,
		"sum_fibers": 12.0,
		"fibers_sum": 12.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125017,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125017",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.16,
		"Date_of_arrival": "2021-08-17T15:00:00",
		"Date_of_Extraction": "2021-08-17T15:00:00",
		"Date_of_Analysis": "2021-08-17T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.201761,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4086.0,
		"woF_15_25": 1503.0,
		"woF_25_50": 1221.0,
		"woF_50_100": 542.0,
		"woF_100_150": 93.0,
		"woF_150_200": 36.0,
		"woF_200_400": 16.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 129.0,
		"woF_300_400": 16.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4086.0,
		"All_15_25": 1503.0,
		"All_25_50": 1221.0,
		"All_50_100": 542.0,
		"All_100_150": 94.0,
		"All_150_200": 36.0,
		"All_200_400": 19.0,
		"All_400_600": 4.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 2.0,
		"All_200_300": 130.0,
		"All_300_400": 21.0,
		"All_400_500": 8.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 705.0,
		"Met_15_25": 566.0,
		"Met_25_50": 805.0,
		"Met_50_100": 474.0,
		"Met_100_150": 89.0,
		"Met_150_200": 33.0,
		"Met_200_400": 16.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 122.0,
		"Met_300_400": 16.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 175.0,
		"woFNM_1W": 67.0,
		"woFNM_2L": 169.0,
		"woFNM_2W": 18.0,
		"woFNM_3L": 167.0,
		"woFNM_3W": 85.0,
		"woFNM_4L": 137.0,
		"woFNM_4W": 31.0,
		"woFNM_5L": 118.0,
		"woFNM_5W": 40.0,
		"Met_1L": 584.0,
		"Met_1W": 40.0,
		"Met_2L": 384.0,
		"Met_2W": 37.0,
		"Met_3L": 360.0,
		"Met_3W": 40.0,
		"Met_4L": 299.0,
		"Met_4W": 45.0,
		"Met_5L": 291.0,
		"Met_5W": 180.0,
		"Fib_Fmax1_Fmax": 2265.0,
		"Fib_Fmax1_Lstr": 2547.0,
		"Fib_Fmax2_Fmax": 1004.0,
		"Fib_Fmax2_Lstr": 1630.0,
		"Fib_Lstr1_Fmax": 2265.0,
		"Fib_Lstr1_Lstr": 2547.0,
		"Fib_Fmax_Sum_um": 8334.0,
		"Fib_Stretched_Sum_um": 10256.0,
		"woF_weighted_sum": 1558.0,
		"All_weighted_sum": 3178.0,
		"Met_weighted_sum": 1447.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125017,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 613.0,
		"nm_sum": 75.0,
		"sum_fibers": 12.0,
		"fibers_sum": 12.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125018,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125018",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.11,
		"Date_of_arrival": "2021-08-18T15:00:00",
		"Date_of_Extraction": "2021-08-18T15:00:00",
		"Date_of_Analysis": "2021-08-18T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.262645,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5016.0,
		"woF_15_25": 1902.0,
		"woF_25_50": 1630.0,
		"woF_50_100": 716.0,
		"woF_100_150": 126.0,
		"woF_150_200": 39.0,
		"woF_200_400": 24.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 165.0,
		"woF_300_400": 26.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5016.0,
		"All_15_25": 1902.0,
		"All_25_50": 1630.0,
		"All_50_100": 716.0,
		"All_100_150": 127.0,
		"All_150_200": 39.0,
		"All_200_400": 27.0,
		"All_400_600": 3.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 166.0,
		"All_300_400": 30.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 947.0,
		"Met_15_25": 750.0,
		"Met_25_50": 1090.0,
		"Met_50_100": 630.0,
		"Met_100_150": 121.0,
		"Met_150_200": 37.0,
		"Met_200_400": 24.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 158.0,
		"Met_300_400": 26.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 169.0,
		"woFNM_1W": 13.0,
		"woFNM_2L": 167.0,
		"woFNM_2W": 22.0,
		"woFNM_3L": 143.0,
		"woFNM_3W": 36.0,
		"woFNM_4L": 116.0,
		"woFNM_4W": 94.0,
		"woFNM_5L": 111.0,
		"woFNM_5W": 35.0,
		"Met_1L": 477.0,
		"Met_1W": 95.0,
		"Met_2L": 419.0,
		"Met_2W": 62.0,
		"Met_3L": 392.0,
		"Met_3W": 76.0,
		"Met_4L": 371.0,
		"Met_4W": 76.0,
		"Met_5L": 354.0,
		"Met_5W": 83.0,
		"Fib_Fmax1_Fmax": 1225.0,
		"Fib_Fmax1_Lstr": 1472.0,
		"Fib_Fmax2_Fmax": 935.0,
		"Fib_Fmax2_Lstr": 1074.0,
		"Fib_Lstr1_Fmax": 1225.0,
		"Fib_Lstr1_Lstr": 1472.0,
		"Fib_Fmax_Sum_um": 4271.0,
		"Fib_Stretched_Sum_um": 5015.0,
		"woF_weighted_sum": 2083.0,
		"All_weighted_sum": 2887.0,
		"Met_weighted_sum": 1959.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125018,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 814.0,
		"nm_sum": 93.0,
		"sum_fibers": 8.0,
		"fibers_sum": 8.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125019,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125019",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.09,
		"Date_of_arrival": "2021-08-19T15:00:00",
		"Date_of_Extraction": "2021-08-19T15:00:00",
		"Date_of_Analysis": "2021-08-19T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.173429,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4433.0,
		"woF_15_25": 1475.0,
		"woF_25_50": 1106.0,
		"woF_50_100": 432.0,
		"woF_100_150": 77.0,
		"woF_150_200": 13.0,
		"woF_200_400": 10.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 90.0,
		"woF_300_400": 10.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4433.0,
		"All_15_25": 1475.0,
		"All_25_50": 1106.0,
		"All_50_100": 432.0,
		"All_100_150": 77.0,
		"All_150_200": 15.0,
		"All_200_400": 11.0,
		"All_400_600": 2.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 92.0,
		"All_300_400": 12.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 578.0,
		"Met_15_25": 491.0,
		"Met_25_50": 644.0,
		"Met_50_100": 359.0,
		"Met_100_150": 74.0,
		"Met_150_200": 12.0,
		"Met_200_400": 9.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 86.0,
		"Met_300_400": 9.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 227.0,
		"woFNM_1W": 57.0,
		"woFNM_2L": 159.0,
		"woFNM_2W": 22.0,
		"woFNM_3L": 141.0,
		"woFNM_3W": 27.0,
		"woFNM_4L": 136.0,
		"woFNM_4W": 31.0,
		"woFNM_5L": 110.0,
		"woFNM_5W": 31.0,
		"Met_1L": 377.0,
		"Met_1W": 74.0,
		"Met_2L": 333.0,
		"Met_2W": 63.0,
		"Met_3L": 296.0,
		"Met_3W": 67.0,
		"Met_4L": 269.0,
		"Met_4W": 48.0,
		"Met_5L": 242.0,
		"Met_5W": 153.0,
		"Fib_Fmax1_Fmax": 815.0,
		"Fib_Fmax1_Lstr": 1030.0,
		"Fib_Fmax2_Fmax": 678.0,
		"Fib_Fmax2_Lstr": 1440.0,
		"Fib_Lstr1_Fmax": 678.0,
		"Fib_Lstr1_Lstr": 1440.0,
		"Fib_Fmax_Sum_um": 3228.0,
		"Fib_Stretched_Sum_um": 4269.0,
		"woF_weighted_sum": 1017.0,
		"All_weighted_sum": 1467.0,
		"Met_weighted_sum": 907.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125019,
		"Passed": "1",
		"zeichnr": "Flansch",
		"met_sum": 454.0,
		"nm_sum": 78.0,
		"sum_fibers": 7.0,
		"fibers_sum": 7.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125020,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125020",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.21,
		"Date_of_arrival": "2021-08-20T15:00:00",
		"Date_of_Extraction": "2021-08-20T15:00:00",
		"Date_of_Analysis": "2021-08-20T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.188152,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 6488.0,
		"woF_15_25": 2002.0,
		"woF_25_50": 1259.0,
		"woF_50_100": 359.0,
		"woF_100_150": 56.0,
		"woF_150_200": 13.0,
		"woF_200_400": 5.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 69.0,
		"woF_300_400": 5.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 6488.0,
		"All_15_25": 2002.0,
		"All_25_50": 1259.0,
		"All_50_100": 359.0,
		"All_100_150": 56.0,
		"All_150_200": 14.0,
		"All_200_400": 9.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 70.0,
		"All_300_400": 10.0,
		"All_400_500": 2.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 500.0,
		"Met_15_25": 427.0,
		"Met_25_50": 555.0,
		"Met_50_100": 258.0,
		"Met_100_150": 52.0,
		"Met_150_200": 13.0,
		"Met_200_400": 5.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 65.0,
		"Met_300_400": 5.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 131.0,
		"woFNM_1W": 71.0,
		"woFNM_2L": 122.0,
		"woFNM_2W": 18.0,
		"woFNM_3L": 121.0,
		"woFNM_3W": 13.0,
		"woFNM_4L": 101.0,
		"woFNM_4W": 54.0,
		"woFNM_5L": 91.0,
		"woFNM_5W": 30.0,
		"Met_1L": 266.0,
		"Met_1W": 67.0,
		"Met_2L": 241.0,
		"Met_2W": 61.0,
		"Met_3L": 227.0,
		"Met_3W": 67.0,
		"Met_4L": 223.0,
		"Met_4W": 54.0,
		"Met_5L": 211.0,
		"Met_5W": 29.0,
		"Fib_Fmax1_Fmax": 988.0,
		"Fib_Fmax1_Lstr": 1198.0,
		"Fib_Fmax2_Fmax": 855.0,
		"Fib_Fmax2_Lstr": 1105.0,
		"Fib_Lstr1_Fmax": 988.0,
		"Fib_Lstr1_Lstr": 1198.0,
		"Fib_Fmax_Sum_um": 3679.0,
		"Fib_Stretched_Sum_um": 4369.0,
		"woF_weighted_sum": 780.0,
		"All_weighted_sum": 1205.0,
		"Met_weighted_sum": 663.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125020,
		"Passed": "1",
		"zeichnr": "Flansch",
		"met_sum": 328.0,
		"nm_sum": 105.0,
		"sum_fibers": 8.0,
		"fibers_sum": 8.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125021,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125021",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.11,
		"Date_of_arrival": "2021-08-21T15:00:00",
		"Date_of_Extraction": "2021-08-21T15:00:00",
		"Date_of_Analysis": "2021-08-21T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.221924,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 9058.0,
		"woF_15_25": 2316.0,
		"woF_25_50": 1424.0,
		"woF_50_100": 400.0,
		"woF_100_150": 67.0,
		"woF_150_200": 17.0,
		"woF_200_400": 5.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 84.0,
		"woF_300_400": 5.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 9058.0,
		"All_15_25": 2316.0,
		"All_25_50": 1424.0,
		"All_50_100": 400.0,
		"All_100_150": 68.0,
		"All_150_200": 18.0,
		"All_200_400": 7.0,
		"All_400_600": 2.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 86.0,
		"All_300_400": 8.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 563.0,
		"Met_15_25": 433.0,
		"Met_25_50": 572.0,
		"Met_50_100": 275.0,
		"Met_100_150": 46.0,
		"Met_150_200": 13.0,
		"Met_200_400": 3.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 59.0,
		"Met_300_400": 3.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 326.0,
		"woFNM_1W": 182.0,
		"woFNM_2L": 211.0,
		"woFNM_2W": 85.0,
		"woFNM_3L": 180.0,
		"woFNM_3W": 31.0,
		"woFNM_4L": 167.0,
		"woFNM_4W": 130.0,
		"woFNM_5L": 165.0,
		"woFNM_5W": 19.0,
		"Met_1L": 358.0,
		"Met_1W": 50.0,
		"Met_2L": 248.0,
		"Met_2W": 45.0,
		"Met_3L": 228.0,
		"Met_3W": 40.0,
		"Met_4L": 191.0,
		"Met_4W": 49.0,
		"Met_5L": 185.0,
		"Met_5W": 18.0,
		"Fib_Fmax1_Fmax": 514.0,
		"Fib_Fmax1_Lstr": 522.0,
		"Fib_Fmax2_Fmax": 473.0,
		"Fib_Fmax2_Lstr": 513.0,
		"Fib_Lstr1_Fmax": 514.0,
		"Fib_Lstr1_Lstr": 522.0,
		"Fib_Fmax_Sum_um": 1806.0,
		"Fib_Stretched_Sum_um": 1867.0,
		"woF_weighted_sum": 901.0,
		"All_weighted_sum": 1074.0,
		"Met_weighted_sum": 624.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125021,
		"Passed": "1",
		"zeichnr": "Flansch",
		"met_sum": 337.0,
		"nm_sum": 152.0,
		"sum_fibers": 6.0,
		"fibers_sum": 6.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125022,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125022",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.29,
		"Date_of_arrival": "2021-08-22T15:00:00",
		"Date_of_Extraction": "2021-08-22T15:00:00",
		"Date_of_Analysis": "2021-08-22T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.319316,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8139.0,
		"woF_15_25": 2533.0,
		"woF_25_50": 1646.0,
		"woF_50_100": 572.0,
		"woF_100_150": 112.0,
		"woF_150_200": 35.0,
		"woF_200_400": 29.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 147.0,
		"woF_300_400": 30.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8139.0,
		"All_15_25": 2533.0,
		"All_25_50": 1646.0,
		"All_50_100": 572.0,
		"All_100_150": 112.0,
		"All_150_200": 37.0,
		"All_200_400": 43.0,
		"All_400_600": 6.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 8.0,
		"All_200_300": 149.0,
		"All_300_400": 48.0,
		"All_400_500": 14.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 657.0,
		"Met_15_25": 585.0,
		"Met_25_50": 764.0,
		"Met_50_100": 378.0,
		"Met_100_150": 64.0,
		"Met_150_200": 23.0,
		"Met_200_400": 12.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 87.0,
		"Met_300_400": 12.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 408.0,
		"woFNM_1W": 78.0,
		"woFNM_2L": 322.0,
		"woFNM_2W": 171.0,
		"woFNM_3L": 319.0,
		"woFNM_3W": 140.0,
		"woFNM_4L": 313.0,
		"woFNM_4W": 157.0,
		"woFNM_5L": 296.0,
		"woFNM_5W": 58.0,
		"Met_1L": 326.0,
		"Met_1W": 184.0,
		"Met_2L": 302.0,
		"Met_2W": 45.0,
		"Met_3L": 286.0,
		"Met_3W": 75.0,
		"Met_4L": 277.0,
		"Met_4W": 56.0,
		"Met_5L": 272.0,
		"Met_5W": 41.0,
		"Fib_Fmax1_Fmax": 6258.0,
		"Fib_Fmax1_Lstr": 6666.0,
		"Fib_Fmax2_Fmax": 2706.0,
		"Fib_Fmax2_Lstr": 2876.0,
		"Fib_Lstr1_Fmax": 6258.0,
		"Fib_Lstr1_Lstr": 6666.0,
		"Fib_Fmax_Sum_um": 29354.0,
		"Fib_Stretched_Sum_um": 34677.0,
		"woF_weighted_sum": 1863.0,
		"All_weighted_sum": 6345.0,
		"Met_weighted_sum": 1033.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125022,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 477.0,
		"nm_sum": 272.0,
		"sum_fibers": 33.0,
		"fibers_sum": 33.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125023,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125023",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.29,
		"Date_of_arrival": "2021-08-23T15:00:00",
		"Date_of_Extraction": "2021-08-23T15:00:00",
		"Date_of_Analysis": "2021-08-23T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.294548,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 7290.0,
		"woF_15_25": 2388.0,
		"woF_25_50": 1728.0,
		"woF_50_100": 584.0,
		"woF_100_150": 120.0,
		"woF_150_200": 55.0,
		"woF_200_400": 25.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 175.0,
		"woF_300_400": 25.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 7290.0,
		"All_15_25": 2388.0,
		"All_25_50": 1728.0,
		"All_50_100": 584.0,
		"All_100_150": 120.0,
		"All_150_200": 55.0,
		"All_200_400": 27.0,
		"All_400_600": 1.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 0.0,
		"All_200_300": 175.0,
		"All_300_400": 28.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 812.0,
		"Met_15_25": 650.0,
		"Met_25_50": 893.0,
		"Met_50_100": 426.0,
		"Met_100_150": 104.0,
		"Met_150_200": 42.0,
		"Met_200_400": 23.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 146.0,
		"Met_300_400": 23.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 372.0,
		"woFNM_1W": 229.0,
		"woFNM_2L": 201.0,
		"woFNM_2W": 117.0,
		"woFNM_3L": 199.0,
		"woFNM_3W": 40.0,
		"woFNM_4L": 192.0,
		"woFNM_4W": 58.0,
		"woFNM_5L": 189.0,
		"woFNM_5W": 58.0,
		"Met_1L": 730.0,
		"Met_1W": 72.0,
		"Met_2L": 362.0,
		"Met_2W": 46.0,
		"Met_3L": 273.0,
		"Met_3W": 143.0,
		"Met_4L": 267.0,
		"Met_4W": 67.0,
		"Met_5L": 262.0,
		"Met_5W": 127.0,
		"Fib_Fmax1_Fmax": 956.0,
		"Fib_Fmax1_Lstr": 1266.0,
		"Fib_Fmax2_Fmax": 745.0,
		"Fib_Fmax2_Lstr": 802.0,
		"Fib_Lstr1_Fmax": 956.0,
		"Fib_Lstr1_Lstr": 1266.0,
		"Fib_Fmax_Sum_um": 2807.0,
		"Fib_Stretched_Sum_um": 3275.0,
		"woF_weighted_sum": 2103.0,
		"All_weighted_sum": 2487.0,
		"Met_weighted_sum": 1732.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125023,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 596.0,
		"nm_sum": 189.0,
		"sum_fibers": 5.0,
		"fibers_sum": 5.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125024,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125024",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.47,
		"Date_of_arrival": "2021-08-24T15:00:00",
		"Date_of_Extraction": "2021-08-24T15:00:00",
		"Date_of_Analysis": "2021-08-24T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.64649,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 15386.0,
		"woF_15_25": 6779.0,
		"woF_25_50": 3112.0,
		"woF_50_100": 1047.0,
		"woF_100_150": 240.0,
		"woF_150_200": 81.0,
		"woF_200_400": 47.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 321.0,
		"woF_300_400": 48.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 15386.0,
		"All_15_25": 6779.0,
		"All_25_50": 3112.0,
		"All_50_100": 1047.0,
		"All_100_150": 240.0,
		"All_150_200": 82.0,
		"All_200_400": 74.0,
		"All_400_600": 8.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 4.0,
		"All_200_300": 322.0,
		"All_300_400": 79.0,
		"All_400_500": 12.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 418.0,
		"Met_15_25": 756.0,
		"Met_25_50": 917.0,
		"Met_50_100": 598.0,
		"Met_100_150": 154.0,
		"Met_150_200": 61.0,
		"Met_200_400": 36.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 215.0,
		"Met_300_400": 37.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 315.0,
		"woFNM_1W": 113.0,
		"woFNM_2L": 271.0,
		"woFNM_2W": 49.0,
		"woFNM_3L": 262.0,
		"woFNM_3W": 154.0,
		"woFNM_4L": 245.0,
		"woFNM_4W": 81.0,
		"woFNM_5L": 234.0,
		"woFNM_5W": 54.0,
		"Met_1L": 427.0,
		"Met_1W": 58.0,
		"Met_2L": 374.0,
		"Met_2W": 59.0,
		"Met_3L": 371.0,
		"Met_3W": 102.0,
		"Met_4L": 321.0,
		"Met_4W": 75.0,
		"Met_5L": 302.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 2438.0,
		"Fib_Fmax1_Lstr": 2612.0,
		"Fib_Fmax2_Fmax": 1609.0,
		"Fib_Fmax2_Lstr": 1821.0,
		"Fib_Lstr1_Fmax": 2438.0,
		"Fib_Lstr1_Lstr": 2612.0,
		"Fib_Fmax_Sum_um": 21978.0,
		"Fib_Stretched_Sum_um": 25592.0,
		"woF_weighted_sum": 3552.0,
		"All_weighted_sum": 6761.0,
		"Met_weighted_sum": 2403.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125024,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 850.0,
		"nm_sum": 566.0,
		"sum_fibers": 43.0,
		"fibers_sum": 43.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125025,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125025",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.37,
		"Date_of_arrival": "2021-08-25T15:00:00",
		"Date_of_Extraction": "2021-08-25T15:00:00",
		"Date_of_Analysis": "2021-08-25T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.299127,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5413.0,
		"woF_15_25": 2562.0,
		"woF_25_50": 1318.0,
		"woF_50_100": 525.0,
		"woF_100_150": 105.0,
		"woF_150_200": 31.0,
		"woF_200_400": 26.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 136.0,
		"woF_300_400": 27.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5413.0,
		"All_15_25": 2562.0,
		"All_25_50": 1318.0,
		"All_50_100": 525.0,
		"All_100_150": 105.0,
		"All_150_200": 33.0,
		"All_200_400": 43.0,
		"All_400_600": 5.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 7.0,
		"All_200_300": 138.0,
		"All_300_400": 45.0,
		"All_400_500": 12.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 4.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 207.0,
		"Met_15_25": 373.0,
		"Met_25_50": 500.0,
		"Met_50_100": 337.0,
		"Met_100_150": 78.0,
		"Met_150_200": 25.0,
		"Met_200_400": 25.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 103.0,
		"Met_300_400": 26.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 341.0,
		"woFNM_1W": 140.0,
		"woFNM_2L": 191.0,
		"woFNM_2W": 81.0,
		"woFNM_3L": 191.0,
		"woFNM_3W": 108.0,
		"woFNM_4L": 176.0,
		"woFNM_4W": 86.0,
		"woFNM_5L": 171.0,
		"woFNM_5W": 11.0,
		"Met_1L": 589.0,
		"Met_1W": 221.0,
		"Met_2L": 462.0,
		"Met_2W": 80.0,
		"Met_3L": 343.0,
		"Met_3W": 73.0,
		"Met_4L": 337.0,
		"Met_4W": 86.0,
		"Met_5L": 337.0,
		"Met_5W": 113.0,
		"Fib_Fmax1_Fmax": 2541.0,
		"Fib_Fmax1_Lstr": 2706.0,
		"Fib_Fmax2_Fmax": 1965.0,
		"Fib_Fmax2_Lstr": 2169.0,
		"Fib_Lstr1_Fmax": 2541.0,
		"Fib_Lstr1_Lstr": 2706.0,
		"Fib_Fmax_Sum_um": 21082.0,
		"Fib_Stretched_Sum_um": 26303.0,
		"woF_weighted_sum": 1768.0,
		"All_weighted_sum": 5338.0,
		"Met_weighted_sum": 1402.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125025,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 467.0,
		"nm_sum": 222.0,
		"sum_fibers": 31.0,
		"fibers_sum": 31.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125026,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125026",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.52,
		"Date_of_arrival": "2021-08-26T15:00:00",
		"Date_of_Extraction": "2021-08-26T15:00:00",
		"Date_of_Analysis": "2021-08-26T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 1.01998,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 43698.0,
		"woF_15_25": 17693.0,
		"woF_25_50": 4827.0,
		"woF_50_100": 770.0,
		"woF_100_150": 98.0,
		"woF_150_200": 34.0,
		"woF_200_400": 11.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 132.0,
		"woF_300_400": 13.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 43698.0,
		"All_15_25": 17693.0,
		"All_25_50": 4827.0,
		"All_50_100": 770.0,
		"All_100_150": 98.0,
		"All_150_200": 36.0,
		"All_200_400": 33.0,
		"All_400_600": 11.0,
		"All_600_1000": 12.0,
		"All_gt_1000": 6.0,
		"All_200_300": 134.0,
		"All_300_400": 43.0,
		"All_400_500": 19.0,
		"All_500_600": null,
		"All_600_700": 7.0,
		"All_700_800": 0.0,
		"All_800_900": 3.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 3.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1129.0,
		"Met_15_25": 2538.0,
		"Met_25_50": 1721.0,
		"Met_50_100": 447.0,
		"Met_100_150": 49.0,
		"Met_150_200": 16.0,
		"Met_200_400": 5.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 65.0,
		"Met_300_400": 6.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 852.0,
		"woFNM_1W": 161.0,
		"woFNM_2L": 440.0,
		"woFNM_2W": 295.0,
		"woFNM_3L": 336.0,
		"woFNM_3W": 214.0,
		"woFNM_4L": 318.0,
		"woFNM_4W": 134.0,
		"woFNM_5L": 295.0,
		"woFNM_5W": 162.0,
		"Met_1L": 439.0,
		"Met_1W": 80.0,
		"Met_2L": 283.0,
		"Met_2W": 134.0,
		"Met_3L": 232.0,
		"Met_3W": 64.0,
		"Met_4L": 218.0,
		"Met_4W": 27.0,
		"Met_5L": 215.0,
		"Met_5W": 21.0,
		"Fib_Fmax1_Fmax": 1732.0,
		"Fib_Fmax1_Lstr": 3601.0,
		"Fib_Fmax2_Fmax": 1648.0,
		"Fib_Fmax2_Lstr": 1972.0,
		"Fib_Lstr1_Fmax": 1732.0,
		"Fib_Lstr1_Lstr": 3601.0,
		"Fib_Fmax_Sum_um": 27421.0,
		"Fib_Stretched_Sum_um": 35884.0,
		"woF_weighted_sum": 1916.0,
		"All_weighted_sum": 6846.0,
		"Met_weighted_sum": 931.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125026,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 518.0,
		"nm_sum": 398.0,
		"sum_fibers": 50.0,
		"fibers_sum": 50.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125027,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125027",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.53,
		"Date_of_arrival": "2021-08-27T15:00:00",
		"Date_of_Extraction": "2021-08-27T15:00:00",
		"Date_of_Analysis": "2021-08-27T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.623152,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 13757.0,
		"woF_15_25": 6370.0,
		"woF_25_50": 3159.0,
		"woF_50_100": 1164.0,
		"woF_100_150": 227.0,
		"woF_150_200": 72.0,
		"woF_200_400": 49.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 299.0,
		"woF_300_400": 52.0,
		"woF_400_500": 3.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 13757.0,
		"All_15_25": 6370.0,
		"All_25_50": 3159.0,
		"All_50_100": 1164.0,
		"All_100_150": 228.0,
		"All_150_200": 72.0,
		"All_200_400": 63.0,
		"All_400_600": 13.0,
		"All_600_1000": 7.0,
		"All_gt_1000": 1.0,
		"All_200_300": 300.0,
		"All_300_400": 70.0,
		"All_400_500": 14.0,
		"All_500_600": null,
		"All_600_700": 4.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 689.0,
		"Met_15_25": 1481.0,
		"Met_25_50": 1525.0,
		"Met_50_100": 826.0,
		"Met_100_150": 171.0,
		"Met_150_200": 52.0,
		"Met_200_400": 36.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 223.0,
		"Met_300_400": 37.0,
		"Met_400_500": 2.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 512.0,
		"woFNM_1W": 204.0,
		"woFNM_2L": 442.0,
		"woFNM_2W": 113.0,
		"woFNM_3L": 417.0,
		"woFNM_3W": 95.0,
		"woFNM_4L": 313.0,
		"woFNM_4W": 102.0,
		"woFNM_5L": 286.0,
		"woFNM_5W": 102.0,
		"Met_1L": 889.0,
		"Met_1W": 175.0,
		"Met_2L": 509.0,
		"Met_2W": 99.0,
		"Met_3L": 423.0,
		"Met_3W": 70.0,
		"Met_4L": 383.0,
		"Met_4W": 50.0,
		"Met_5L": 337.0,
		"Met_5W": 226.0,
		"Fib_Fmax1_Fmax": 1087.0,
		"Fib_Fmax1_Lstr": 1149.0,
		"Fib_Fmax2_Fmax": 836.0,
		"Fib_Fmax2_Lstr": 942.0,
		"Fib_Lstr1_Fmax": 686.0,
		"Fib_Lstr1_Lstr": 1228.0,
		"Fib_Fmax_Sum_um": 13736.0,
		"Fib_Stretched_Sum_um": 16799.0,
		"woF_weighted_sum": 3968.0,
		"All_weighted_sum": 5972.0,
		"Met_weighted_sum": 2826.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125027,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1088.0,
		"nm_sum": 430.0,
		"sum_fibers": 30.0,
		"fibers_sum": 30.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125028,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125028",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.39,
		"Date_of_arrival": "2021-08-28T15:00:00",
		"Date_of_Extraction": "2021-08-28T15:00:00",
		"Date_of_Analysis": "2021-08-28T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.384088,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8885.0,
		"woF_15_25": 2889.0,
		"woF_25_50": 2349.0,
		"woF_50_100": 801.0,
		"woF_100_150": 141.0,
		"woF_150_200": 53.0,
		"woF_200_400": 25.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 194.0,
		"woF_300_400": 27.0,
		"woF_400_500": 2.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8885.0,
		"All_15_25": 2889.0,
		"All_25_50": 2349.0,
		"All_50_100": 801.0,
		"All_100_150": 142.0,
		"All_150_200": 57.0,
		"All_200_400": 46.0,
		"All_400_600": 10.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 1.0,
		"All_200_300": 199.0,
		"All_300_400": 53.0,
		"All_400_500": 10.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 3.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 891.0,
		"Met_15_25": 775.0,
		"Met_25_50": 1126.0,
		"Met_50_100": 549.0,
		"Met_100_150": 110.0,
		"Met_150_200": 38.0,
		"Met_200_400": 23.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 148.0,
		"Met_300_400": 25.0,
		"Met_400_500": 2.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 374.0,
		"woFNM_1W": 71.0,
		"woFNM_2L": 260.0,
		"woFNM_2W": 118.0,
		"woFNM_3L": 193.0,
		"woFNM_3W": 38.0,
		"woFNM_4L": 192.0,
		"woFNM_4W": 71.0,
		"woFNM_5L": 181.0,
		"woFNM_5W": 52.0,
		"Met_1L": 701.0,
		"Met_1W": 255.0,
		"Met_2L": 542.0,
		"Met_2W": 46.0,
		"Met_3L": 475.0,
		"Met_3W": 78.0,
		"Met_4L": 411.0,
		"Met_4W": 61.0,
		"Met_5L": 391.0,
		"Met_5W": 42.0,
		"Fib_Fmax1_Fmax": 1064.0,
		"Fib_Fmax1_Lstr": 1349.0,
		"Fib_Fmax2_Fmax": 967.0,
		"Fib_Fmax2_Lstr": 978.0,
		"Fib_Lstr1_Fmax": 735.0,
		"Fib_Lstr1_Lstr": 1404.0,
		"Fib_Fmax_Sum_um": 14836.0,
		"Fib_Stretched_Sum_um": 17906.0,
		"woF_weighted_sum": 2578.0,
		"All_weighted_sum": 4522.0,
		"Met_weighted_sum": 2035.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125028,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 724.0,
		"nm_sum": 300.0,
		"sum_fibers": 39.0,
		"fibers_sum": 39.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125029,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125029",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.47,
		"Date_of_arrival": "2021-08-29T15:00:00",
		"Date_of_Extraction": "2021-08-29T15:00:00",
		"Date_of_Analysis": "2021-08-29T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.647506,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8861.0,
		"woF_15_25": 4681.0,
		"woF_25_50": 2774.0,
		"woF_50_100": 1235.0,
		"woF_100_150": 273.0,
		"woF_150_200": 87.0,
		"woF_200_400": 65.0,
		"woF_400_600": 8.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 360.0,
		"woF_300_400": 69.0,
		"woF_400_500": 7.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 2.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8861.0,
		"All_15_25": 4681.0,
		"All_25_50": 2774.0,
		"All_50_100": 1235.0,
		"All_100_150": 273.0,
		"All_150_200": 87.0,
		"All_200_400": 78.0,
		"All_400_600": 16.0,
		"All_600_1000": 7.0,
		"All_gt_1000": 4.0,
		"All_200_300": 360.0,
		"All_300_400": 85.0,
		"All_400_500": 20.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 3.0,
		"All_800_900": 2.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 510.0,
		"Met_15_25": 1070.0,
		"Met_25_50": 1262.0,
		"Met_50_100": 909.0,
		"Met_100_150": 232.0,
		"Met_150_200": 80.0,
		"Met_200_400": 62.0,
		"Met_400_600": 7.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 312.0,
		"Met_300_400": 66.0,
		"Met_400_500": 6.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 2.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 512.0,
		"woFNM_1W": 68.0,
		"woFNM_2L": 308.0,
		"woFNM_2W": 38.0,
		"woFNM_3L": 254.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 249.0,
		"woFNM_4W": 60.0,
		"woFNM_5L": 182.0,
		"woFNM_5W": 27.0,
		"Met_1L": 1022.0,
		"Met_1W": 156.0,
		"Met_2L": 785.0,
		"Met_2W": 205.0,
		"Met_3L": 712.0,
		"Met_3W": 242.0,
		"Met_4L": 571.0,
		"Met_4W": 108.0,
		"Met_5L": 569.0,
		"Met_5W": 92.0,
		"Fib_Fmax1_Fmax": 1540.0,
		"Fib_Fmax1_Lstr": 2477.0,
		"Fib_Fmax2_Fmax": 1473.0,
		"Fib_Fmax2_Lstr": 1897.0,
		"Fib_Lstr1_Fmax": 1540.0,
		"Fib_Lstr1_Lstr": 2477.0,
		"Fib_Fmax_Sum_um": 16476.0,
		"Fib_Stretched_Sum_um": 21076.0,
		"woF_weighted_sum": 5350.0,
		"All_weighted_sum": 7990.0,
		"Met_weighted_sum": 4685.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125029,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1293.0,
		"nm_sum": 378.0,
		"sum_fibers": 29.0,
		"fibers_sum": 29.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125030,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125030",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.32,
		"Date_of_arrival": "2021-08-30T15:00:00",
		"Date_of_Extraction": "2021-08-30T15:00:00",
		"Date_of_Analysis": "2021-08-30T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.345444,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5677.0,
		"woF_15_25": 2257.0,
		"woF_25_50": 1971.0,
		"woF_50_100": 738.0,
		"woF_100_150": 155.0,
		"woF_150_200": 60.0,
		"woF_200_400": 27.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 215.0,
		"woF_300_400": 27.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5677.0,
		"All_15_25": 2257.0,
		"All_25_50": 1971.0,
		"All_50_100": 738.0,
		"All_100_150": 156.0,
		"All_150_200": 78.0,
		"All_200_400": 74.0,
		"All_400_600": 13.0,
		"All_600_1000": 8.0,
		"All_gt_1000": 5.0,
		"All_200_300": 234.0,
		"All_300_400": 80.0,
		"All_400_500": 20.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 4.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 741.0,
		"Met_15_25": 670.0,
		"Met_25_50": 972.0,
		"Met_50_100": 501.0,
		"Met_100_150": 105.0,
		"Met_150_200": 44.0,
		"Met_200_400": 24.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 149.0,
		"Met_300_400": 24.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 319.0,
		"woFNM_1W": 72.0,
		"woFNM_2L": 247.0,
		"woFNM_2W": 85.0,
		"woFNM_3L": 220.0,
		"woFNM_3W": 125.0,
		"woFNM_4L": 177.0,
		"woFNM_4W": 49.0,
		"woFNM_5L": 170.0,
		"woFNM_5W": 18.0,
		"Met_1L": 595.0,
		"Met_1W": 40.0,
		"Met_2L": 346.0,
		"Met_2W": 81.0,
		"Met_3L": 327.0,
		"Met_3W": 40.0,
		"Met_4L": 310.0,
		"Met_4W": 40.0,
		"Met_5L": 301.0,
		"Met_5W": 45.0,
		"Fib_Fmax1_Fmax": 2252.0,
		"Fib_Fmax1_Lstr": 2493.0,
		"Fib_Fmax2_Fmax": 1413.0,
		"Fib_Fmax2_Lstr": 1597.0,
		"Fib_Lstr1_Fmax": 2252.0,
		"Fib_Lstr1_Lstr": 2493.0,
		"Fib_Fmax_Sum_um": 35365.0,
		"Fib_Stretched_Sum_um": 42324.0,
		"woF_weighted_sum": 2394.0,
		"All_weighted_sum": 7232.0,
		"Met_weighted_sum": 1765.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125030,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 675.0,
		"nm_sum": 306.0,
		"sum_fibers": 90.0,
		"fibers_sum": 90.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125031,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125031",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.45,
		"Date_of_arrival": "2021-08-31T15:00:00",
		"Date_of_Extraction": "2021-08-31T15:00:00",
		"Date_of_Analysis": "2021-08-31T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.663508,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 17560.0,
		"woF_15_25": 5965.0,
		"woF_25_50": 4089.0,
		"woF_50_100": 1298.0,
		"woF_100_150": 267.0,
		"woF_150_200": 83.0,
		"woF_200_400": 44.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 350.0,
		"woF_300_400": 45.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 17560.0,
		"All_15_25": 5965.0,
		"All_25_50": 4089.0,
		"All_50_100": 1300.0,
		"All_100_150": 267.0,
		"All_150_200": 84.0,
		"All_200_400": 57.0,
		"All_400_600": 4.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 4.0,
		"All_200_300": 351.0,
		"All_300_400": 59.0,
		"All_400_500": 12.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1409.0,
		"Met_15_25": 1085.0,
		"Met_25_50": 1435.0,
		"Met_50_100": 766.0,
		"Met_100_150": 187.0,
		"Met_150_200": 55.0,
		"Met_200_400": 31.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 242.0,
		"Met_300_400": 31.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 441.0,
		"woFNM_1W": 302.0,
		"woFNM_2L": 318.0,
		"woFNM_2W": 221.0,
		"woFNM_3L": 316.0,
		"woFNM_3W": 135.0,
		"woFNM_4L": 283.0,
		"woFNM_4W": 163.0,
		"woFNM_5L": 266.0,
		"woFNM_5W": 86.0,
		"Met_1L": 377.0,
		"Met_1W": 68.0,
		"Met_2L": 364.0,
		"Met_2W": 41.0,
		"Met_3L": 356.0,
		"Met_3W": 39.0,
		"Met_4L": 338.0,
		"Met_4W": 73.0,
		"Met_5L": 338.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 1956.0,
		"Fib_Fmax1_Lstr": 2431.0,
		"Fib_Fmax2_Fmax": 1738.0,
		"Fib_Fmax2_Lstr": 2157.0,
		"Fib_Lstr1_Fmax": 1956.0,
		"Fib_Lstr1_Lstr": 2431.0,
		"Fib_Fmax_Sum_um": 15358.0,
		"Fib_Stretched_Sum_um": 17716.0,
		"woF_weighted_sum": 3881.0,
		"All_weighted_sum": 6756.0,
		"Met_weighted_sum": 2505.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125031,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1039.0,
		"nm_sum": 654.0,
		"sum_fibers": 29.0,
		"fibers_sum": 29.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125032,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125032",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.51,
		"Date_of_arrival": "2021-09-01T15:00:00",
		"Date_of_Extraction": "2021-09-01T15:00:00",
		"Date_of_Analysis": "2021-09-01T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.414903,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 5996.0,
		"woF_15_25": 2362.0,
		"woF_25_50": 2080.0,
		"woF_50_100": 954.0,
		"woF_100_150": 220.0,
		"woF_150_200": 63.0,
		"woF_200_400": 44.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 283.0,
		"woF_300_400": 44.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 5996.0,
		"All_15_25": 2362.0,
		"All_25_50": 2080.0,
		"All_50_100": 954.0,
		"All_100_150": 220.0,
		"All_150_200": 66.0,
		"All_200_400": 59.0,
		"All_400_600": 2.0,
		"All_600_1000": 8.0,
		"All_gt_1000": 6.0,
		"All_200_300": 286.0,
		"All_300_400": 60.0,
		"All_400_500": 15.0,
		"All_500_600": null,
		"All_600_700": 4.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 555.0,
		"Met_15_25": 554.0,
		"Met_25_50": 974.0,
		"Met_50_100": 744.0,
		"Met_100_150": 187.0,
		"Met_150_200": 59.0,
		"Met_200_400": 42.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 246.0,
		"Met_300_400": 42.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 281.0,
		"woFNM_1W": 172.0,
		"woFNM_2L": 227.0,
		"woFNM_2W": 108.0,
		"woFNM_3L": 185.0,
		"woFNM_3W": 36.0,
		"woFNM_4L": 159.0,
		"woFNM_4W": 49.0,
		"woFNM_5L": 157.0,
		"woFNM_5W": 64.0,
		"Met_1L": 369.0,
		"Met_1W": 144.0,
		"Met_2L": 358.0,
		"Met_2W": 100.0,
		"Met_3L": 354.0,
		"Met_3W": 180.0,
		"Met_4L": 323.0,
		"Met_4W": 81.0,
		"Met_5L": 306.0,
		"Met_5W": 90.0,
		"Fib_Fmax1_Fmax": 1592.0,
		"Fib_Fmax1_Lstr": 1718.0,
		"Fib_Fmax2_Fmax": 1464.0,
		"Fib_Fmax2_Lstr": 1882.0,
		"Fib_Lstr1_Fmax": 1464.0,
		"Fib_Lstr1_Lstr": 1882.0,
		"Fib_Fmax_Sum_um": 19417.0,
		"Fib_Stretched_Sum_um": 22740.0,
		"woF_weighted_sum": 3105.0,
		"All_weighted_sum": 7052.0,
		"Met_weighted_sum": 2695.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125032,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1032.0,
		"nm_sum": 249.0,
		"sum_fibers": 34.0,
		"fibers_sum": 34.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125033,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125033",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.78,
		"Date_of_arrival": "2021-09-02T15:00:00",
		"Date_of_Extraction": "2021-09-02T15:00:00",
		"Date_of_Analysis": "2021-09-02T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.436417,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 10119.0,
		"woF_15_25": 3004.0,
		"woF_25_50": 2409.0,
		"woF_50_100": 739.0,
		"woF_100_150": 119.0,
		"woF_150_200": 44.0,
		"woF_200_400": 27.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 3.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 163.0,
		"woF_300_400": 32.0,
		"woF_400_500": 4.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 2.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 10119.0,
		"All_15_25": 3004.0,
		"All_25_50": 2409.0,
		"All_50_100": 739.0,
		"All_100_150": 121.0,
		"All_150_200": 47.0,
		"All_200_400": 38.0,
		"All_400_600": 9.0,
		"All_600_1000": 12.0,
		"All_gt_1000": 6.0,
		"All_200_300": 168.0,
		"All_300_400": 46.0,
		"All_400_500": 19.0,
		"All_500_600": null,
		"All_600_700": 6.0,
		"All_700_800": 3.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1031.0,
		"Met_15_25": 783.0,
		"Met_25_50": 1147.0,
		"Met_50_100": 508.0,
		"Met_100_150": 85.0,
		"Met_150_200": 32.0,
		"Met_200_400": 20.0,
		"Met_400_600": 5.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 117.0,
		"Met_300_400": 25.0,
		"Met_400_500": 3.0,
		"Met_500_600": null,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 1.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 895.0,
		"woFNM_1W": 648.0,
		"woFNM_2L": 352.0,
		"woFNM_2W": 133.0,
		"woFNM_3L": 227.0,
		"woFNM_3W": 33.0,
		"woFNM_4L": 219.0,
		"woFNM_4W": 90.0,
		"woFNM_5L": 207.0,
		"woFNM_5W": 62.0,
		"Met_1L": 1791.0,
		"Met_1W": 512.0,
		"Met_2L": 885.0,
		"Met_2W": 55.0,
		"Met_3L": 678.0,
		"Met_3W": 111.0,
		"Met_4L": 493.0,
		"Met_4W": 17.0,
		"Met_5L": 487.0,
		"Met_5W": 95.0,
		"Fib_Fmax1_Fmax": 2337.0,
		"Fib_Fmax1_Lstr": 2821.0,
		"Fib_Fmax2_Fmax": 2113.0,
		"Fib_Fmax2_Lstr": 2713.0,
		"Fib_Lstr1_Fmax": 2337.0,
		"Fib_Lstr1_Lstr": 2821.0,
		"Fib_Fmax_Sum_um": 20646.0,
		"Fib_Stretched_Sum_um": 25517.0,
		"woF_weighted_sum": 3195.0,
		"All_weighted_sum": 6958.0,
		"Met_weighted_sum": 2464.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125033,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 653.0,
		"nm_sum": 285.0,
		"sum_fibers": 32.0,
		"fibers_sum": 32.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125034,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125034",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.7,
		"Date_of_arrival": "2021-09-03T15:00:00",
		"Date_of_Extraction": "2021-09-03T15:00:00",
		"Date_of_Analysis": "2021-09-03T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.52191,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 15957.0,
		"woF_15_25": 5079.0,
		"woF_25_50": 3289.0,
		"woF_50_100": 939.0,
		"woF_100_150": 145.0,
		"woF_150_200": 32.0,
		"woF_200_400": 20.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 177.0,
		"woF_300_400": 21.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 15957.0,
		"All_15_25": 5079.0,
		"All_25_50": 3289.0,
		"All_50_100": 940.0,
		"All_100_150": 145.0,
		"All_150_200": 32.0,
		"All_200_400": 34.0,
		"All_400_600": 6.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 3.0,
		"All_200_300": 177.0,
		"All_300_400": 37.0,
		"All_400_500": 12.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3969.0,
		"Met_15_25": 2654.0,
		"Met_25_50": 2255.0,
		"Met_50_100": 732.0,
		"Met_100_150": 116.0,
		"Met_150_200": 26.0,
		"Met_200_400": 17.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 142.0,
		"Met_300_400": 17.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 404.0,
		"woFNM_1W": 278.0,
		"woFNM_2L": 227.0,
		"woFNM_2W": 36.0,
		"woFNM_3L": 211.0,
		"woFNM_3W": 148.0,
		"woFNM_4L": 211.0,
		"woFNM_4W": 135.0,
		"woFNM_5L": 198.0,
		"woFNM_5W": 22.0,
		"Met_1L": 375.0,
		"Met_1W": 81.0,
		"Met_2L": 325.0,
		"Met_2W": 166.0,
		"Met_3L": 301.0,
		"Met_3W": 260.0,
		"Met_4L": 299.0,
		"Met_4W": 55.0,
		"Met_5L": 275.0,
		"Met_5W": 67.0,
		"Fib_Fmax1_Fmax": 1570.0,
		"Fib_Fmax1_Lstr": 1625.0,
		"Fib_Fmax2_Fmax": 1560.0,
		"Fib_Fmax2_Lstr": 1693.0,
		"Fib_Lstr1_Fmax": 1560.0,
		"Fib_Lstr1_Lstr": 1693.0,
		"Fib_Fmax_Sum_um": 15781.0,
		"Fib_Stretched_Sum_um": 19104.0,
		"woF_weighted_sum": 2191.0,
		"All_weighted_sum": 4800.0,
		"Met_weighted_sum": 1702.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125034,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 891.0,
		"nm_sum": 246.0,
		"sum_fibers": 29.0,
		"fibers_sum": 29.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125035,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125035",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.41,
		"Date_of_arrival": "2021-09-04T15:00:00",
		"Date_of_Extraction": "2021-09-04T15:00:00",
		"Date_of_Analysis": "2021-09-04T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.554061,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 16355.0,
		"woF_15_25": 4667.0,
		"woF_25_50": 3705.0,
		"woF_50_100": 1121.0,
		"woF_100_150": 213.0,
		"woF_150_200": 44.0,
		"woF_200_400": 19.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 257.0,
		"woF_300_400": 19.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 16355.0,
		"All_15_25": 4667.0,
		"All_25_50": 3705.0,
		"All_50_100": 1121.0,
		"All_100_150": 215.0,
		"All_150_200": 48.0,
		"All_200_400": 45.0,
		"All_400_600": 5.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 4.0,
		"All_200_300": 263.0,
		"All_300_400": 47.0,
		"All_400_500": 13.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 3367.0,
		"Met_15_25": 2085.0,
		"Met_25_50": 2281.0,
		"Met_50_100": 839.0,
		"Met_100_150": 162.0,
		"Met_150_200": 37.0,
		"Met_200_400": 15.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 199.0,
		"Met_300_400": 15.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 606.0,
		"woFNM_1W": 203.0,
		"woFNM_2L": 308.0,
		"woFNM_2W": 43.0,
		"woFNM_3L": 251.0,
		"woFNM_3W": 83.0,
		"woFNM_4L": 215.0,
		"woFNM_4W": 136.0,
		"woFNM_5L": 201.0,
		"woFNM_5W": 96.0,
		"Met_1L": 387.0,
		"Met_1W": 71.0,
		"Met_2L": 385.0,
		"Met_2W": 127.0,
		"Met_3L": 275.0,
		"Met_3W": 109.0,
		"Met_4L": 271.0,
		"Met_4W": 21.0,
		"Met_5L": 245.0,
		"Met_5W": 24.0,
		"Fib_Fmax1_Fmax": 3778.0,
		"Fib_Fmax1_Lstr": 3901.0,
		"Fib_Fmax2_Fmax": 1778.0,
		"Fib_Fmax2_Lstr": 3287.0,
		"Fib_Lstr1_Fmax": 3778.0,
		"Fib_Lstr1_Lstr": 3901.0,
		"Fib_Fmax_Sum_um": 23091.0,
		"Fib_Stretched_Sum_um": 26662.0,
		"woF_weighted_sum": 2817.0,
		"All_weighted_sum": 5917.0,
		"Met_weighted_sum": 2060.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 125035,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1053.0,
		"nm_sum": 345.0,
		"sum_fibers": 46.0,
		"fibers_sum": 46.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125036,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125036",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-05T15:00:00",
		"Date_of_Extraction": "2021-09-05T15:00:00",
		"Date_of_Analysis": "2021-09-05T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.697209,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11263.0,
		"woF_15_25": 6367.0,
		"woF_25_50": 3768.0,
		"woF_50_100": 1288.0,
		"woF_100_150": 262.0,
		"woF_150_200": 75.0,
		"woF_200_400": 51.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 337.0,
		"woF_300_400": 52.0,
		"woF_400_500": 2.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11263.0,
		"All_15_25": 6367.0,
		"All_25_50": 3768.0,
		"All_50_100": 1288.0,
		"All_100_150": 262.0,
		"All_150_200": 83.0,
		"All_200_400": 60.0,
		"All_400_600": 8.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 4.0,
		"All_200_300": 345.0,
		"All_300_400": 63.0,
		"All_400_500": 20.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 6.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1219.0,
		"Met_15_25": 2403.0,
		"Met_25_50": 2496.0,
		"Met_50_100": 1092.0,
		"Met_100_150": 238.0,
		"Met_150_200": 66.0,
		"Met_200_400": 49.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 304.0,
		"Met_300_400": 50.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 517.0,
		"woFNM_1W": 156.0,
		"woFNM_2L": 281.0,
		"woFNM_2W": 172.0,
		"woFNM_3L": 275.0,
		"woFNM_3W": 201.0,
		"woFNM_4L": 187.0,
		"woFNM_4W": 21.0,
		"woFNM_5L": 172.0,
		"woFNM_5W": 21.0,
		"Met_1L": 1012.0,
		"Met_1W": 398.0,
		"Met_2L": 430.0,
		"Met_2W": 87.0,
		"Met_3L": 383.0,
		"Met_3W": 46.0,
		"Met_4L": 335.0,
		"Met_4W": 124.0,
		"Met_5L": 332.0,
		"Met_5W": 70.0,
		"Fib_Fmax1_Fmax": 1365.0,
		"Fib_Fmax1_Lstr": 1870.0,
		"Fib_Fmax2_Fmax": 1267.0,
		"Fib_Fmax2_Lstr": 1561.0,
		"Fib_Lstr1_Fmax": 1365.0,
		"Fib_Lstr1_Lstr": 1870.0,
		"Fib_Fmax_Sum_um": 18748.0,
		"Fib_Stretched_Sum_um": 22878.0,
		"woF_weighted_sum": 4355.0,
		"All_weighted_sum": 7739.0,
		"Met_weighted_sum": 3886.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 1.0,
		"Fib_strlength_150_200": 4.0,
		"Fib_strlength_200_400": 10.0,
		"Fib_strlength_400_600": 6.0,
		"Fib_strlength_600_1000": 9.0,
		"Fib_strlength_gt_1000": 7.0,
		"Fib_strlength_200_300": 5.0,
		"Fib_strlength_300_400": 13.0,
		"Fib_strlength_400_500": 19.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 2.0,
		"Fib_strlength_700_800": 4.0,
		"Fib_strlength_800_900": 1.0,
		"Fib_strlength_900_1000": 2.0,
		"Fib_strlength_1000_1500": 5.0,
		"Fib_strlength_1500_2000": 2.0,
		"Fib_strlength_2000_2500": 0.0,
		"Fib_strlength_2500_3000": 0.0,
		"Fib_strlength_gt_3000": 0.0,
		"analysis_int": 125036,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1447.0,
		"nm_sum": 232.0,
		"sum_fibers": 37.0,
		"fibers_sum": 37.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125037,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125037",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-06T15:00:00",
		"Date_of_Extraction": "2021-09-06T15:00:00",
		"Date_of_Analysis": "2021-09-06T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.669077,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 14763.0,
		"woF_15_25": 4085.0,
		"woF_25_50": 3934.0,
		"woF_50_100": 1304.0,
		"woF_100_150": 268.0,
		"woF_150_200": 77.0,
		"woF_200_400": 58.0,
		"woF_400_600": 8.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 345.0,
		"woF_300_400": 64.0,
		"woF_400_500": 5.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 14763.0,
		"All_15_25": 4085.0,
		"All_25_50": 3934.0,
		"All_50_100": 1307.0,
		"All_100_150": 269.0,
		"All_150_200": 79.0,
		"All_200_400": 68.0,
		"All_400_600": 18.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 4.0,
		"All_200_300": 348.0,
		"All_300_400": 79.0,
		"All_400_500": 16.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1824.0,
		"Met_15_25": 1597.0,
		"Met_25_50": 2458.0,
		"Met_50_100": 1026.0,
		"Met_100_150": 222.0,
		"Met_150_200": 58.0,
		"Met_200_400": 43.0,
		"Met_400_600": 7.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 280.0,
		"Met_300_400": 48.0,
		"Met_400_500": 5.0,
		"Met_500_600": null,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 413.0,
		"woFNM_1W": 212.0,
		"woFNM_2L": 390.0,
		"woFNM_2W": 172.0,
		"woFNM_3L": 324.0,
		"woFNM_3W": 188.0,
		"woFNM_4L": 318.0,
		"woFNM_4W": 57.0,
		"woFNM_5L": 313.0,
		"woFNM_5W": 188.0,
		"Met_1L": 1028.0,
		"Met_1W": 116.0,
		"Met_2L": 813.0,
		"Met_2W": 185.0,
		"Met_3L": 601.0,
		"Met_3W": 141.0,
		"Met_4L": 583.0,
		"Met_4W": 65.0,
		"Met_5L": 501.0,
		"Met_5W": 94.0,
		"Fib_Fmax1_Fmax": 2495.0,
		"Fib_Fmax1_Lstr": 2586.0,
		"Fib_Fmax2_Fmax": 1909.0,
		"Fib_Fmax2_Lstr": 2144.0,
		"Fib_Lstr1_Fmax": 2495.0,
		"Fib_Lstr1_Lstr": 2586.0,
		"Fib_Fmax_Sum_um": 16470.0,
		"Fib_Stretched_Sum_um": 19779.0,
		"woF_weighted_sum": 5197.0,
		"All_weighted_sum": 7654.0,
		"Met_weighted_sum": 4260.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 3.0,
		"Fib_strlength_100_150": 1.0,
		"Fib_strlength_150_200": 0.0,
		"Fib_strlength_200_400": 11.0,
		"Fib_strlength_400_600": 5.0,
		"Fib_strlength_600_1000": 7.0,
		"Fib_strlength_gt_1000": 5.0,
		"Fib_strlength_200_300": 1.0,
		"Fib_strlength_300_400": 15.0,
		"Fib_strlength_400_500": 13.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 4.0,
		"Fib_strlength_700_800": 1.0,
		"Fib_strlength_800_900": 1.0,
		"Fib_strlength_900_1000": 1.0,
		"Fib_strlength_1000_1500": 2.0,
		"Fib_strlength_1500_2000": 1.0,
		"Fib_strlength_2000_2500": 1.0,
		"Fib_strlength_2500_3000": 1.0,
		"Fib_strlength_gt_3000": 0.0,
		"analysis_int": 125037,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1359.0,
		"nm_sum": 359.0,
		"sum_fibers": 31.0,
		"fibers_sum": 31.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125038,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125038",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-07T15:00:00",
		"Date_of_Extraction": "2021-09-07T15:00:00",
		"Date_of_Analysis": "2021-09-07T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.595683,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11821.0,
		"woF_15_25": 3750.0,
		"woF_25_50": 3153.0,
		"woF_50_100": 1043.0,
		"woF_100_150": 204.0,
		"woF_150_200": 74.0,
		"woF_200_400": 51.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 278.0,
		"woF_300_400": 54.0,
		"woF_400_500": 2.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11821.0,
		"All_15_25": 3750.0,
		"All_25_50": 3153.0,
		"All_50_100": 1043.0,
		"All_100_150": 205.0,
		"All_150_200": 80.0,
		"All_200_400": 72.0,
		"All_400_600": 15.0,
		"All_600_1000": 10.0,
		"All_gt_1000": 8.0,
		"All_200_300": 285.0,
		"All_300_400": 79.0,
		"All_400_500": 26.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 2.0,
		"All_800_900": 4.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 7.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1553.0,
		"Met_15_25": 1374.0,
		"Met_25_50": 1833.0,
		"Met_50_100": 802.0,
		"Met_100_150": 158.0,
		"Met_150_200": 56.0,
		"Met_200_400": 46.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 214.0,
		"Met_300_400": 48.0,
		"Met_400_500": 2.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 1.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 461.0,
		"woFNM_1W": 312.0,
		"woFNM_2L": 342.0,
		"woFNM_2W": 114.0,
		"woFNM_3L": 330.0,
		"woFNM_3W": 180.0,
		"woFNM_4L": 243.0,
		"woFNM_4W": 181.0,
		"woFNM_5L": 203.0,
		"woFNM_5W": 90.0,
		"Met_1L": 838.0,
		"Met_1W": 437.0,
		"Met_2L": 523.0,
		"Met_2W": 57.0,
		"Met_3L": 481.0,
		"Met_3W": 123.0,
		"Met_4L": 460.0,
		"Met_4W": 62.0,
		"Met_5L": 399.0,
		"Met_5W": 163.0,
		"Fib_Fmax1_Fmax": 2380.0,
		"Fib_Fmax1_Lstr": 2753.0,
		"Fib_Fmax2_Fmax": 1480.0,
		"Fib_Fmax2_Lstr": 2007.0,
		"Fib_Lstr1_Fmax": 2380.0,
		"Fib_Lstr1_Lstr": 2753.0,
		"Fib_Fmax_Sum_um": 31778.0,
		"Fib_Stretched_Sum_um": 38609.0,
		"woF_weighted_sum": 3741.0,
		"All_weighted_sum": 9335.0,
		"Met_weighted_sum": 3010.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 1.0,
		"Fib_strlength_150_200": 3.0,
		"Fib_strlength_200_400": 22.0,
		"Fib_strlength_400_600": 9.0,
		"Fib_strlength_600_1000": 10.0,
		"Fib_strlength_gt_1000": 11.0,
		"Fib_strlength_200_300": 4.0,
		"Fib_strlength_300_400": 26.0,
		"Fib_strlength_400_500": 26.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 2.0,
		"Fib_strlength_700_800": 1.0,
		"Fib_strlength_800_900": 3.0,
		"Fib_strlength_900_1000": 4.0,
		"Fib_strlength_1000_1500": 6.0,
		"Fib_strlength_1500_2000": 2.0,
		"Fib_strlength_2000_2500": 2.0,
		"Fib_strlength_2500_3000": 1.0,
		"Fib_strlength_gt_3000": 0.0,
		"analysis_int": 125038,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1066.0,
		"nm_sum": 311.0,
		"sum_fibers": 55.0,
		"fibers_sum": 55.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125039,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125039",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-08T15:00:00",
		"Date_of_Extraction": "2021-09-08T15:00:00",
		"Date_of_Analysis": "2021-09-08T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.66781,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 14537.0,
		"woF_15_25": 5551.0,
		"woF_25_50": 4017.0,
		"woF_50_100": 1427.0,
		"woF_100_150": 252.0,
		"woF_150_200": 67.0,
		"woF_200_400": 40.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 319.0,
		"woF_300_400": 42.0,
		"woF_400_500": 2.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 14537.0,
		"All_15_25": 5551.0,
		"All_25_50": 4017.0,
		"All_50_100": 1427.0,
		"All_100_150": 252.0,
		"All_150_200": 69.0,
		"All_200_400": 45.0,
		"All_400_600": 9.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 5.0,
		"All_200_300": 321.0,
		"All_300_400": 50.0,
		"All_400_500": 14.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2592.0,
		"Met_15_25": 2589.0,
		"Met_25_50": 2632.0,
		"Met_50_100": 1094.0,
		"Met_100_150": 204.0,
		"Met_150_200": 55.0,
		"Met_200_400": 24.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 259.0,
		"Met_300_400": 24.0,
		"Met_400_500": 1.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 608.0,
		"woFNM_1W": 292.0,
		"woFNM_2L": 432.0,
		"woFNM_2W": 126.0,
		"woFNM_3L": 424.0,
		"woFNM_3W": 133.0,
		"woFNM_4L": 394.0,
		"woFNM_4W": 107.0,
		"woFNM_5L": 351.0,
		"woFNM_5W": 116.0,
		"Met_1L": 730.0,
		"Met_1W": 92.0,
		"Met_2L": 387.0,
		"Met_2W": 67.0,
		"Met_3L": 370.0,
		"Met_3W": 130.0,
		"Met_4L": 316.0,
		"Met_4W": 197.0,
		"Met_5L": 286.0,
		"Met_5W": 63.0,
		"Fib_Fmax1_Fmax": 1556.0,
		"Fib_Fmax1_Lstr": 1597.0,
		"Fib_Fmax2_Fmax": 1129.0,
		"Fib_Fmax2_Lstr": 1308.0,
		"Fib_Lstr1_Fmax": 1052.0,
		"Fib_Lstr1_Lstr": 2505.0,
		"Fib_Fmax_Sum_um": 13909.0,
		"Fib_Stretched_Sum_um": 17877.0,
		"woF_weighted_sum": 4094.0,
		"All_weighted_sum": 7072.0,
		"Met_weighted_sum": 2933.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 0.0,
		"Fib_strlength_150_200": 1.0,
		"Fib_strlength_200_400": 4.0,
		"Fib_strlength_400_600": 7.0,
		"Fib_strlength_600_1000": 4.0,
		"Fib_strlength_gt_1000": 6.0,
		"Fib_strlength_200_300": 1.0,
		"Fib_strlength_300_400": 7.0,
		"Fib_strlength_400_500": 14.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 0.0,
		"Fib_strlength_700_800": 0.0,
		"Fib_strlength_800_900": 3.0,
		"Fib_strlength_900_1000": 1.0,
		"Fib_strlength_1000_1500": 3.0,
		"Fib_strlength_1500_2000": 2.0,
		"Fib_strlength_2000_2500": 0.0,
		"Fib_strlength_2500_3000": 1.0,
		"Fib_strlength_gt_3000": 0.0,
		"analysis_int": 125039,
		"Passed": "0",
		"zeichnr": "Flansch",
		"met_sum": 1378.0,
		"nm_sum": 412.0,
		"sum_fibers": 22.0,
		"fibers_sum": 22.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125040,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125040",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-09T15:00:00",
		"Date_of_Extraction": "2021-09-09T15:00:00",
		"Date_of_Analysis": "2021-09-09T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.431419,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 10887.0,
		"woF_15_25": 4017.0,
		"woF_25_50": 2782.0,
		"woF_50_100": 872.0,
		"woF_100_150": 130.0,
		"woF_150_200": 27.0,
		"woF_200_400": 24.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 157.0,
		"woF_300_400": 25.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 10887.0,
		"All_15_25": 4017.0,
		"All_25_50": 2782.0,
		"All_50_100": 872.0,
		"All_100_150": 131.0,
		"All_150_200": 27.0,
		"All_200_400": 38.0,
		"All_400_600": 4.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 5.0,
		"All_200_300": 158.0,
		"All_300_400": 40.0,
		"All_400_500": 11.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 1495.0,
		"Met_15_25": 1528.0,
		"Met_25_50": 1512.0,
		"Met_50_100": 535.0,
		"Met_100_150": 83.0,
		"Met_150_200": 14.0,
		"Met_200_400": 16.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 97.0,
		"Met_300_400": 17.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 316.0,
		"woFNM_1W": 54.0,
		"woFNM_2L": 303.0,
		"woFNM_2W": 130.0,
		"woFNM_3L": 291.0,
		"woFNM_3W": 49.0,
		"woFNM_4L": 223.0,
		"woFNM_4W": 130.0,
		"woFNM_5L": 217.0,
		"woFNM_5W": 56.0,
		"Met_1L": 424.0,
		"Met_1W": 108.0,
		"Met_2L": 390.0,
		"Met_2W": 118.0,
		"Met_3L": 292.0,
		"Met_3W": 197.0,
		"Met_4L": 268.0,
		"Met_4W": 74.0,
		"Met_5L": 263.0,
		"Met_5W": 135.0,
		"Fib_Fmax1_Fmax": 3011.0,
		"Fib_Fmax1_Lstr": 3506.0,
		"Fib_Fmax2_Fmax": 1495.0,
		"Fib_Fmax2_Lstr": 1817.0,
		"Fib_Lstr1_Fmax": 3011.0,
		"Fib_Lstr1_Lstr": 3506.0,
		"Fib_Fmax_Sum_um": 16509.0,
		"Fib_Stretched_Sum_um": 20992.0,
		"woF_weighted_sum": 2083.0,
		"All_weighted_sum": 5079.0,
		"Met_weighted_sum": 1313.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 1.0,
		"Fib_strlength_150_200": 0.0,
		"Fib_strlength_200_400": 11.0,
		"Fib_strlength_400_600": 5.0,
		"Fib_strlength_600_1000": 3.0,
		"Fib_strlength_gt_1000": 7.0,
		"Fib_strlength_200_300": 1.0,
		"Fib_strlength_300_400": 14.0,
		"Fib_strlength_400_500": 12.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 0.0,
		"Fib_strlength_700_800": 3.0,
		"Fib_strlength_800_900": 0.0,
		"Fib_strlength_900_1000": 0.0,
		"Fib_strlength_1000_1500": 4.0,
		"Fib_strlength_1500_2000": 1.0,
		"Fib_strlength_2000_2500": 1.0,
		"Fib_strlength_2500_3000": 0.0,
		"Fib_strlength_gt_3000": 1.0,
		"analysis_int": 125040,
		"Passed": "0",
		"zeichnr": "Flansch",
		"new": true,
		"met_sum": 649.0,
		"nm_sum": 405.0,
		"sum_fibers": 27.0,
		"fibers_sum": 27.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Flansch",
		"betaufnr": 125041,
		"kdnr": 12345,
		"artnr": "5123434",
		"Analysis_No": "125041",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Date_of_arrival": "2021-09-10T15:00:00",
		"Date_of_Extraction": "2021-09-10T15:00:00",
		"Date_of_Analysis": "2021-09-10T15:00:00",
		"Component": "Flansch",
		"Component_No": "XYZ",
		"Testing_Specification": "5123434",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,7 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.788045,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 17204.0,
		"woF_15_25": 5266.0,
		"woF_25_50": 4408.0,
		"woF_50_100": 1465.0,
		"woF_100_150": 276.0,
		"woF_150_200": 85.0,
		"woF_200_400": 53.0,
		"woF_400_600": 9.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 361.0,
		"woF_300_400": 60.0,
		"woF_400_500": 4.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 17204.0,
		"All_15_25": 5266.0,
		"All_25_50": 4408.0,
		"All_50_100": 1465.0,
		"All_100_150": 280.0,
		"All_150_200": 94.0,
		"All_200_400": 81.0,
		"All_400_600": 28.0,
		"All_600_1000": 12.0,
		"All_gt_1000": 3.0,
		"All_200_300": 374.0,
		"All_300_400": 104.0,
		"All_400_500": 20.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 4.0,
		"All_800_900": 4.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3700.0,
		"Met_15_25": 2767.0,
		"Met_25_50": 3127.0,
		"Met_50_100": 1227.0,
		"Met_100_150": 250.0,
		"Met_150_200": 78.0,
		"Met_200_400": 51.0,
		"Met_400_600": 9.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 328.0,
		"Met_300_400": 58.0,
		"Met_400_500": 4.0,
		"Met_500_600": null,
		"Met_600_700": 1.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 221.0,
		"woFNM_1W": 84.0,
		"woFNM_2L": 206.0,
		"woFNM_2W": 51.0,
		"woFNM_3L": 188.0,
		"woFNM_3W": 117.0,
		"woFNM_4L": 180.0,
		"woFNM_4W": 140.0,
		"woFNM_5L": 175.0,
		"woFNM_5W": 123.0,
		"Met_1L": 757.0,
		"Met_1W": 256.0,
		"Met_2L": 654.0,
		"Met_2W": 431.0,
		"Met_3L": 598.0,
		"Met_3W": 87.0,
		"Met_4L": 575.0,
		"Met_4W": 294.0,
		"Met_5L": 492.0,
		"Met_5W": 71.0,
		"Fib_Fmax1_Fmax": 2409.0,
		"Fib_Fmax1_Lstr": 2858.0,
		"Fib_Fmax2_Fmax": 1139.0,
		"Fib_Fmax2_Lstr": 1885.0,
		"Fib_Lstr1_Fmax": 2409.0,
		"Fib_Lstr1_Lstr": 2858.0,
		"Fib_Fmax_Sum_um": 32067.0,
		"Fib_Stretched_Sum_um": 42117.0,
		"woF_weighted_sum": 5046.0,
		"All_weighted_sum": 9447.0,
		"Met_weighted_sum": 4609.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 4.0,
		"Fib_strlength_150_200": 8.0,
		"Fib_strlength_200_400": 15.0,
		"Fib_strlength_400_600": 27.0,
		"Fib_strlength_600_1000": 8.0,
		"Fib_strlength_gt_1000": 11.0,
		"Fib_strlength_200_300": 12.0,
		"Fib_strlength_300_400": 25.0,
		"Fib_strlength_400_500": 36.0,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": 4.0,
		"Fib_strlength_700_800": 1.0,
		"Fib_strlength_800_900": 1.0,
		"Fib_strlength_900_1000": 2.0,
		"Fib_strlength_1000_1500": 8.0,
		"Fib_strlength_1500_2000": 1.0,
		"Fib_strlength_2000_2500": 1.0,
		"Fib_strlength_2500_3000": 1.0,
		"Fib_strlength_gt_3000": 0.0,
		"analysis_int": 125041,
		"Passed": "0",
		"zeichnr": "Flansch",
		"new": true,
		"met_sum": 1617.0,
		"nm_sum": 273.0,
		"sum_fibers": 72.0,
		"fibers_sum": 72.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	}
]
